import React, { useEffect, useState, useRef, use } from 'react'
import { set, useForm, Controller } from "react-hook-form";
import axios from "axios";
import DOMPurify from 'dompurify';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import { Tabs, Tab, Chip, Tooltip, Box, Paper } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';
import {
    SaveFolderName, getFolderList, CreateAgentBasic, LLMandVoiceConfiguration, getAIAgentsbyID, getAIAgentsbyIDLLMData, getAIAgentsbyIDTranscriber,
    TranscriberProviderAPI, TranscriberProviderUpdateAPI, UpdateAgentBasic, LLMandVoiceConfigurationUpdate, AgentSummaryAPI, AgentSummaryUpdateAPI,
    PredefinedFunctionsUpdateAPI, PredefinedFunctionsAPI, getAIAgentsbyIDSummary, getAIAgentsbyIDPredefinedFunctions, CallPrivacyUpdateAPI, CallPrivacyAPI, getAIAgentsbyIDCallPrivacy,
    getLLMConfigurationsList,
    getLLMModelsList,
    getVoiceConfigurationsList,
    getTranscriberConfigs,
    getVoiceModelList,
    getTranscriberLanguage,
    getFolders
} from './../../utils/APIClient'
import { login, triggerAlert, ConfirmationAlert } from './../../utils/commonFunctions'
import { data, Link, useNavigate } from 'react-router-dom';

import { getOnlyToken } from '../../utils/commonFunctions';
import { useLocation } from "react-router-dom";
import Loader from '../../Components/Loader';
import Header from '../../common/Header';
import Sidebar from '../../common/Sidebar';
import { Button } from 'react-bootstrap';
export default function AgentCreation({ agentName, goToNextStep, flowID, agentType, agentid }) {
    const location = useLocation();
    const promptId = location.state?.promptId;

    console.log("Prompt ID:", promptId);
    useEffect(() => {
        if (promptId) {
            setValue("prompt_id", promptId);
        }
    }, [promptId]);


    // document.title = "Callingo | Agent Creation"
    let url = new URL(window.location.href);
    let params = new URLSearchParams(url.search.slice(1));
    let obj = {};
    for (let pair of params.entries()) {
        obj[pair[0]] = pair[1];
    }
    const agetid = obj["agentid"] ? obj["agentid"] : agentid;
    const isupdate = obj["isupdate"];
    const naviation = useNavigate();
    const [step, setstep] = useState(0)
    const [hide, sethide] = useState(false)
    const [foldersList, setfolderList] = useState([])
    const [languages, setLanguages] = useState([])
    const [errorModal, setErrorModal] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [promptMode, setPromptMode] = useState(null);
    const [buildModal, setbuildModal] = useState(false);
    const [cusModal, setcusModal] = useState(false);
    const [loader, setLoader] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [selectedType, setSelectedType] = useState(" ");
    const [searchFilter, setSearchFilter] = useState("");
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [personaLoading, setPerLoading] = useState(false)
    const [flowchartHtml, setFlowchartHtml] = useState(null);
    const flowchartRef = useRef(null);
    const editVoiceCodeRef = useRef(null);
    const [languageCode, setLnguageCode] = useState('');
    const [showFullscreenModal, setShowFullscreenModal] = useState(false);
    const [modalZoomLevel, setModalZoomLevel] = useState(1);
    const [zoomLevel, setZoomLevel] = useState(1);
    const [headers, setHeaders] = useState([{ key: "", value: "" }])



    const navigate = useNavigate();
    const menuRef = useRef()


    const [advancedSettings, setAdvancedSettings] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);
    const { register, handleSubmit, formState: { errors }, watch, reset, setValue, getValues, trigger, clearErrors, control } = useForm({
        defaultValues: {
            agent_name: agentName || "",
            confidence_threshold: 0.5,
            silence_duration: 0.5,
            summary_request_timeout: 30,
            minimum_number_of_messages_trigger: 5,
            wait_seconds: 30,
            on_punctuation_seconds: 50,
            on_number_seconds: 50,
            silence_timeout: 50,
            maximum_duration: 50
        }
    });
    const { register: register2, handleSubmit: handleSubmit2, formState: { errors: errors2 } } = useForm({
        defaultValues: {
            background_denoising: false,
            use_numerals: false,
            enable_end_call_function: false,
            dial_keypad: false,
            auto_meeting_scheduling: false,
            call_back_function: false,
            hipaa_compliance: false,
            pci_compliance: false,
            audio_recording: false
        }
    });
    const { register: register3, handleSubmit: handleSubmit3, formState: { errors: errors3 }, setValue: setValue3, reset: reset3 } = useForm();
    const { register: register1, formState: { errors: errors1 }, handleSubmit: handleSubmit1, reset: reset1, trigger: trigger1, setValue: setValue1 } = useForm();
    // const { register: register4, formState: { errors: errors4 }, handleSubmit: handleSubmit4, reset: reset4, trigger: trigger4 } = useForm();

    const [fileDataArray, setFileDataArray] = useState([]);
    const [fileDataArray2, setFileDataArray2] = useState([]);
    const MAX_FILE_SIZE = 1 * 1024 * 1024; // 1MB
    const [agentID, setagentID] = useState();
    const [disabled, setdisabled] = useState(false);
    // Store data from Step 0 and Step 1
    const [step0Data, setStep0Data] = useState({});
    const [step1Data, setStep1Data] = useState({});
    const [scratchLoading, setScratchLoading] = useState(false);
    const [aiLoading, setAiLoading] = useState(false);
    const [customFunctionLoading, setCustomFunctionLoading] = useState(false);
    const [providersModels, setprovidersModels] = useState([]);
    const [models, setModels] = useState([]);
    const [voiceModels, setVoiceModels] = useState([]);
    const [VoiceprovidersModels, setVoiceprovidersModels] = useState([]);
    const [TranscriberprovidersModels, setTranscriberprovidersModels] = useState([]);
    const [transcribelanguage, setTranscriberLanguage] = useState([]);
    const [selectedVoiceAudio, setSelectedVoiceAudio] = useState(null);
    const [personaModal, setpersonaModal] = useState(false);
    const steps = [
        { id: 0, label: "Profile", icon: "bi-person-circle", tooltip: "Configure basic agent details and voice settings" },
        { id: 1, label: "Integrations", icon: "bi-building", tooltip: "Configure greeting message and API integrations" },
        { id: 2, label: "Agent Flow Description", icon: "bi-diagram-3-fill", tooltip: "Define system prompt and workflow" },
        // Advanced Settings Steps (shown when advancedSettings is true)
        ...(advancedSettings ? [
            { id: 3, label: "Speech-to-Text Engine", icon: "bi-mic", tooltip: "Configure transcription settings" },
            { id: 4, label: "Agent Capabilities", icon: "bi-tools", tooltip: "Enable agent functions and features" },
            { id: 5, label: "Advanced Settings", icon: "bi-gear", tooltip: "Configure call behavior and timeouts" },
        ] : [])
    ];

    console.log('agent details', agentName, agentType);

    useEffect(() => {
        if (agentName) {
            setValue("agent_name", agentName);
            console.log('Setting agent_name to:', agentName);
        }
    }, [agentName, setValue]);

    const updateIframeZoom = (zoom, panX = 0, panY = 0) => {
        const iframe = document.querySelector(
            "iframe[title='Flowchart Diagram Fullscreen']"
        );
        if (!iframe || !iframe.contentDocument) return;

        const body = iframe.contentDocument.body;
        if (body) {
            body.style.transform = `scale(${zoom}) translate(${panX}px, ${panY}px)`;
            body.style.transformOrigin = '0 0';
            body.style.transition = 'transform 0.2s ease';
        }

        iframe.style.overflow = 'auto';
    };

    const [panPosition, setPanPosition] = useState({ x: 0, y: 0 });

    const handleZoomChange = (delta) => {
        setModalZoomLevel(prev => {
            const next = Math.min(3, Math.max(0.3, prev + delta));
            updateIframeZoom(next, panPosition.x, panPosition.y);
            return next;
        });
    };

    const syncIframeZoom = () => {
        updateIframeZoom(modalZoomLevel, panPosition.x, panPosition.y);
    };


    const onSubmitpersons = async (data) => {
        setScratchLoading(true);
        const token = getOnlyToken();

        const payload = {
            first_message: data.first_message,
            prompt_role: data.prompt_role,
            type: data.agent_type,
            prompt: data.prompt,
        };

        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };

        try {
            const res = await axios.post("/api/agents/default-prompt/create/", payload, config);
            const promptId = res.data.data.prompt_id;

            setpersonaModal(false);
            setSuccessMessage('System prompt created successfully!');
            setShowSuccessModal(true);

            setTimeout(() => {
                setShowSuccessModal(false);
                navigate("/agentcreation", {
                    state: { promptId: promptId }
                });
            }, 1500);

        } catch (error) {
            console.log("Error:", error);
            setpersonaModal(false);
            setErrorMessage(error.response?.data?.message || 'Failed to create system prompt. Please try again.');
            setErrorModal(true);
        } finally {
            setScratchLoading(false);
        }
    };
    const onSubmitAI = async (data) => {
        setAiLoading(true);
        setdisabled(true);
        const token = getOnlyToken();

        const payload = {
            agent_type: agentType,
            user_response: data.user_response,
        };

        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };

        try {
            const res = await axios.post("/api/agents/ai-prompt-generate/", payload, config);
            const promptId = res.data.data.prompt_id;
            if ((res.status === 200 || res.status === 201) && promptMode === "scratch") {
                setValue("system_prompt", res.data.data.prompt);
                console.log("Generated Prompt:", res.data.data.prompt);
            }

            setbuildModal(false);
            triggerAlert('success', '', 'AI-generated system prompt created successfully!');


        } catch (error) {
            console.error("Error:", error);
            triggerAlert('error', '', error.response?.data?.message || 'Failed to generate AI prompt. Please try again.');
        } finally {
            setAiLoading(false);
            setdisabled(false);
        }
    };

    const handleAgentTypeChange = (agentType) => {
        const newType = selectedType === agentType ? " " : agentType;
        setSelectedType(newType);
        fetchSystemPromptModels(selectedFilter, newType, searchFilter);
    };

    const handleSearchFilterChange = (searchValue) => {
        setSearchFilter(searchValue);
    };

    const SidebarCard = ({ item, selectedId, handleSelect }) => {
        const id = String(item.prompt_id);

        return (
            <div
                className="px-3 py-2 rounded border bg-light text-primary h-100"
                onClick={() => handleSelect(item.prompt_id)}
                style={{ cursor: "pointer", transition: "all 0.2s ease", minHeight: "150px" }}
            >
                <div className="d-flex gap-2 align-items-center mb-2">
                    <div
                        className="d-flex align-items-center justify-content-center rounded-circle flex-shrink-0 "
                        style={{ width: "48px", height: "48px", color: "#aed1ffff", backgroundColor: '#014670' }}
                    >
                        <i className={`${item.icon} fs-4`} />
                    </div>

                    <div className="flex-grow-1 min-w-0" style={{ overflowWrap: "break-word", wordBreak: "break-word" }}>
                        <h4
                            className="mb-1 fs-5 fw-bold text-primary"
                            style={{ whiteSpace: "normal", lineHeight: "1.2" }}
                        >
                            {item.prompt_name}
                        </h4>
                        {item.type && <span className="small fw-semibold bg-success-subtle px-1 rounded-5" style={{ color: '#105f1d' }}>{item.type}</span>}
                    </div>
                </div>

                <p
                    className="mb-0 text-black small "
                // style={{ whiteSpace: "normal", lineHeight: "1.2" }}
                >
                    {item.prompt_role}
                </p>
            </div>
        );
    };



    const FilterSidebar = ({ selectedFilter, onFilterChange }) => {
        const filterItems = [
            {
                id: "all",
                label: "All Templates",
                icon: "bi bi-grid"
            },
            {
                id: "business",
                label: "Default Template",
                icon: "bi-file-earmark-text"
            },
            {
                id: "creative",
                label: "AI Generated",
                icon: "bi-stars"
            },
        ];




        return (
            <div className="pe-2  mt-0 border-end h-100" style={{ minWidth: "180px", boxShadow: '2px 0 5px rgba(189, 212, 245, 0.45)' }}>
                <h5 className="mb-2 mt-1 fw-bold ps-1 fs-4 text-center" style={{ color: '#014076' }}>  Filters</h5>

                <div className="d-flex flex-column gap-2">
                    {filterItems.map((filter) => (
                        <div
                            key={filter.id}
                            className={`p-2 rounded
                               
                                `}
                            onClick={() => onFilterChange(filter.id)}
                            style={{
                                cursor: "pointer",
                                backgroundColor:
                                    selectedFilter === filter.id ? "#014076" : "#eceef8",
                                color: selectedFilter === filter.id ? "#ffffff" : "#000000",
                                border: selectedFilter === filter.id ? "none" : "1px solid #aaa9bd",
                            }}


                        >
                            <div className="d-flex align-items-center gap-2">
                                <i className={`${filter.icon} ${selectedFilter === filter.id ? 'text-success' : ''}`} />
                                <span className="small fw-medium">{filter.label}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    };

    useEffect(() => {
        fetchIntegrations()
    }, [])

    const fetchIntegrations = async () => {
        const token = getOnlyToken();
        const config = { headers: { Authorization: `Bearer ${token}` } }
        const resp = await axios.get('api/agents/custom-functions/create/', config)

        setAllIntegrations(resp.data.data);
        const options = resp.data.data.map(integration => ({
            value: integration.id,
            label: integration.function_name
        }));
        setIntegrationOptions(options);
    }




    // const getFolderLists = async () => {
    //     try {
    //         let folders = await getFolderList();
    //         if (folders.data) {
    //             if (folders.data.status_code == 200) {
    //                 setfolderList([...folders.data.folders])
    //             }
    //         }
    //     } catch (error) {
    //         console.error(error);
    //     }
    // }

    const getLanguages = async () => {
        try {
            const token = getOnlyToken();
            const config = {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            };
            const res = await axios.get(`/api/agents/get-tts-languages/?provider=${selectedVoiceProvider}`, config);
            if (res.data) {
                if (res.data.status_code == 200) {
                    setLanguages(res.data.data.languages)
                }
            }
        } catch (error) {
            console.error(error);
        }
    }
    const getLLMProvidersAndModels = async () => {
        try {
            let LLMProvider = await getLLMConfigurationsList();
            if (LLMProvider.data) {
                setprovidersModels([...LLMProvider.data])
            }
        } catch (error) {
            console.error(error);
        }
    }
    const getLLMModels = async (provider) => {
        if (!provider) return; // guard clause

        const token = getOnlyToken();
        try {
            const response = await axios.get(`api/agents/get-llm/`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { provider }
            });

            if (response.data) {
                setModels(response.data);
            }
        } catch (error) {
            console.error("Error fetching LLM models:", error);
        }
    };


    const selectedProvider = watch("llm_provider");

    useEffect(() => {
        if (selectedProvider) {
            getLLMModels(selectedProvider);
        }
    }, [selectedProvider]);



    const getVoiceProvidersAndModels = async () => {
        try {
            let VoiceProvider = await getVoiceConfigurationsList();
            if (VoiceProvider.data) {
                setVoiceprovidersModels(VoiceProvider.data.providers);
            }
        } catch (error) {
            console.error(error);
        }
    }
    const selectedVoiceProvider = watch("voice_provider");
    const selectedLanguage = watch("language_agent");
    const selectedAgentType = watch("agent_type");
    const profilePictureAgentTypes = ['out-bound'];
    const selectedGender = watch("gender")
    const getVoiceModels = async () => {
        if (!selectedLanguage || !selectedGender) return;
        const token = getOnlyToken();
        try {
            setLoading(true);
            setValue("voice_code", "");
            const params = new URLSearchParams({
                language: selectedLanguage,
                gender: selectedGender,
                provider: selectedVoiceProvider || 'google_text_to_speech'
            });
            const response = await axios.get(`api/agents/get-voices/?${params.toString()}`, {
                headers: { Authorization: `Bearer ${token}` },
            });

            if (response.data) {
                console.log("Fetched voice models:", response.data.data);
                setVoiceModels(response.data.data);
                // setValue("language_code", response.data.data[0].language_code);
                setLnguageCode(response.data.data[0].language_code);
            }
        } catch (error) {
            console.error("Error fetching voice models:", error);
            setValue("voice_code", "");
            setVoiceModels([]);
        } finally {
            setLoading(false);
        }
    };
    console.log(languageCode, 'languageCode');
    useEffect(() => {
        if (selectedLanguage && selectedGender) {
            getVoiceModels();
        }
    }, [selectedLanguage, selectedGender]);
    // Fetch languages based on selected voice provider and reset AI Voice
    useEffect(() => {
        if (selectedVoiceProvider) {
            setValue("voice_code", "");
            setVoiceModels([]);
            getLanguages();
        }
    }, [selectedVoiceProvider]);

    // Re-apply the saved voice_code once voice models load during edit mode.
    // Why: setting language_agent / gender / voice_provider triggers effects that
    // reset voice_code, racing with the setValue calls in getAIAgents*.
    useEffect(() => {
        if (editVoiceCodeRef.current && voiceModels.length > 0) {
            const exists = voiceModels.find(
                (v) => v.voice_code === editVoiceCodeRef.current
            );
            if (exists) {
                setValue("voice_code", editVoiceCodeRef.current);
                editVoiceCodeRef.current = null;
            }
        }
    }, [voiceModels]);

    // Watch for voice_code changes to update audio preview
    const selectedVoiceCode = watch("voice_code");
    useEffect(() => {
        if (selectedVoiceCode && voiceModels.length > 0) {
            const selectedVoice = voiceModels.find(voice => voice.voice_code === selectedVoiceCode);
            if (selectedVoice && selectedVoice.audio_file) {
                // Construct full URL for audio file
                const audioUrl = `${'https://engine.callingo.ai'}${selectedVoice.audio_file}`;
                console.log("Selected voice audio URL:", audioUrl);

                setSelectedVoiceAudio(audioUrl);
            } else {
                setSelectedVoiceAudio(null);
            }
        } else {
            setSelectedVoiceAudio(null);
        }
    }, [selectedVoiceCode, voiceModels]);


    const getTranscriberProvidersAndModels = async () => {
        try {
            let TranscriberProvider = await getTranscriberConfigs();
            if (TranscriberProvider.data) {
                setTranscriberprovidersModels([...TranscriberProvider.data])
            }
        } catch (error) {
            console.error(error);
        }
    }
    const selectedTranscriberProvider = watch("transcriber_provider");
    const getTranscriberLanguageModels = async (selectedProvider, setTranscriberLanguage) => {
        const token = getOnlyToken();

        try {
            const response = await axios.get(`api/agents/get-speech-to-text/`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params: {
                    provider: selectedProvider,
                },
            });

            if (response.data) {
                setTranscriberLanguage([...response.data]);
            }
        } catch (error) {
            console.error("Error fetching Transcriber Language Models:", error);
        }
    };
    const [transcriberModelsData, setTranscriberModelsData] = useState([]); // raw data from API
    const [availableModels, setAvailableModels] = useState([]);             // filtered models
    const [availableLanguages, setAvailableLanguages] = useState([]);       // filtered languages

    const handleTranscriberProviderChange = async (e) => {
        const selectedProvider = e.target.value;
        setValue("transcriber_provider", selectedProvider);
        setValue("model", "");
        setValue("language", "");
        setAvailableLanguages([]);

        if (!selectedProvider) return;

        const token = getOnlyToken();
        try {
            const response = await axios.get(`api/agents/get-speech-to-text/`, {
                headers: { Authorization: `Bearer ${token}` },
                params: { provider: selectedProvider },
            });

            if (response.data) {
                setTranscriberModelsData(response.data);
                const modelList = response.data.map(item => item.model);
                setAvailableModels(modelList);
            }
        } catch (error) {
            console.error("Error fetching models:", error);
        }
    };

    const handleModelChange = (e) => {
        const selectedModel = e.target.value;
        setValue("model", selectedModel);
        setValue("language", "");

        const modelData = transcriberModelsData.find(item => item.model === selectedModel);
        if (modelData?.languages) {
            const languageOptions = Object.entries(modelData.languages).map(([name, code]) => ({
                name,
                code
            }));
            setAvailableLanguages(languageOptions);
        } else {
            setAvailableLanguages([]);
        }
    };



    useEffect(() => {
        if (selectedTranscriberProvider) {
            getTranscriberLanguageModels(selectedTranscriberProvider, setTranscriberLanguage);
        }
    }, [selectedTranscriberProvider]);

    const getFileNameFromUrl = (url) => {
        return url.split('/').pop().split('?')[0]; // removes query params
    };
    const getMimeTypeFromExtension = (filename) => {
        const extension = filename.split('.').pop().toLowerCase();
        const mimeTypes = {
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            png: 'image/png',
            gif: 'image/gif',
            webp: 'image/webp',
            bmp: 'image/bmp',
            svg: 'image/svg+xml',
        };
        return mimeTypes[extension] || 'application/octet-stream'; // fallback
    };
    const createImageObjectFromUrl = (url) => {
        const name = getFileNameFromUrl(url);
        const type = getMimeTypeFromExtension(name);

        return { url, name, type };
    };
    const getAIAgents = async (id) => {
        try {
            setLoading(true)
            let aiagent = await getAIAgentsbyID(id);
            if (aiagent.data) {
                setPromptMode('Edit')
                // setValue('about_the_company', aiagent.data.data.about_the_company)
                // setValue('agent_company_name', aiagent.data.data.company_name)
                // setValue('agent_company_website', aiagent.data.data.company_website)
                setValue('greeting_message', aiagent.data.data.first_message)
                setValue('additional_information', aiagent.data.data.additional_info)
                setValue('agent_name', aiagent.data.data.agent_name)
                setValue('agent_position', aiagent.data.data.agent_position)
                setValue('meeting_duration', aiagent.data.data.meeting_duration)
                setValue('language_agent', aiagent.data.data.language)
                setValue('goal', aiagent.data.data.goal)
                editVoiceCodeRef.current = aiagent.data.data.voice_code
                setValue('voice_code', aiagent.data.data.voice_code)
                setValue('gender', aiagent.data.data.gender)
                setValue('voice_provider', aiagent.data.data.voice_provider)
                setValue('agent_type', aiagent.data.data.agent_type)
                if (aiagent.data.data.agent_plan) {
                    setValue('pack_price', aiagent.data.data.agent_plan.pack_price ?? '');
                    setValue('pack_units', aiagent.data.data.agent_plan.pack_units ?? '');
                    setValue('unit_label', aiagent.data.data.agent_plan.unit_label ?? '');
                }
                // integrations → set as array
                const integrations = aiagent.data.data.integrations;
                if (integrations && Array.isArray(integrations)) {
                    setValue("connected_integrations", integrations);
                } else if (integrations) {
                    setValue("connected_integrations", [integrations]);
                } else {
                    setValue("connected_integrations", []);
                }
                setValue('system_prompt', aiagent.data.data.prompt)

                if (aiagent.data.data.html) {
                    setFlowchartHtml(aiagent.data.data.html);
                }

                if (aiagent.data.data.profile_picture) {
                    let object = createImageObjectFromUrl(aiagent.data.data.profile_picture);
                    setFileDataArray2([object])
                }

                // if (aiagent.data.data.documents.length > 0) {
                //     aiagent.data.data.documents.map(() => {
                //         let completeUrl = process.env.REACT_APP_API_BASE_URL + aiagent.data.data.documents
                //     let object = createImageObjectFromUrl(completeUrl);
                //     })

                //     setFileDataArray([object])
                // }
            }
        } catch (error) {
            console.error(error);
            setLoading(false)
        } finally {
            setLoading(false)
        }
    }


    const getAIAgentsLLMData = async (id) => {
        try {
            let aiagent = await getAIAgentsbyIDLLMData(id);
            if (aiagent.data) {
                // Ensure LLM providers are loaded before setting value
                await getLLMProvidersAndModels();
                const llmProvider = aiagent.data.data.llm_provider;
                const llmModel = aiagent.data.data.llm_model;
                setValue('llm_provider', llmProvider);
                if (llmProvider) {
                    await getLLMModels(llmProvider);
                    setTimeout(() => {
                        setValue('llm_model', llmModel);
                    }, 200);
                }

                setValue('first_message', aiagent.data.data.first_message);
                setValue('temperature', aiagent.data.data.temperature);

                // Voice Provider and Code
                const voiceProvider = aiagent.data.data.voice_provider;
                const voiceCode = aiagent.data.data.voice_code;
                // Stash voice_code; the voiceModels effect re-applies it once models load,
                // surviving the resets triggered by language/gender/provider setValue calls.
                if (voiceCode) editVoiceCodeRef.current = voiceCode;
                setValue('voice_provider', voiceProvider);
                setValue('language_code', aiagent.data.data.language_code);

                setValue('system_prompt', aiagent.data.data.system_prompt);
                setValue('background_sound', aiagent.data.data.background_sound);
                setValue('max_output_tokens', aiagent.data.data.max_output_tokens);
            }
        } catch (error) {
            console.error(error);
        }
    }
    const getAIAgentsbyIDTranscr = async (id) => {
        try {
            let aiagent = await getAIAgentsbyIDTranscriber(id);
            if (aiagent.data) {
                const provider = aiagent.data.data.transcriber_provider;
                const model = aiagent.data.data.model;
                const language = aiagent.data.data.language;
                setValue('transcriber_provider', provider);
                // Fetch models for provider, then set model and fetch languages
                setTimeout(async () => {
                    if (provider) {
                        const token = getOnlyToken();
                        try {
                            const response = await axios.get(`api/agents/get-speech-to-text/`, {
                                headers: { Authorization: `Bearer ${token}` },
                                params: { provider }
                            });
                            if (response.data) {
                                setTranscriberModelsData(response.data);
                                const modelList = response.data.map(item => item.model);
                                // Ensure setValue('model', ...) is called after setAvailableModels
                                setAvailableModels(modelList);
                                // Wait for next tick to ensure state update
                                setTimeout(() => {
                                    setValue('model', model);
                                    // Now populate languages for the selected model
                                    const modelData = response.data.find(item => item.model === model);
                                    if (modelData?.languages) {
                                        const languageOptions = Object.entries(modelData.languages).map(([name, code]) => ({ name, code }));
                                        setAvailableLanguages(languageOptions);
                                        setTimeout(() => {
                                            setValue('language', language);
                                        }, 200);
                                    } else {
                                        setAvailableLanguages([]);
                                    }
                                }, 100);
                            }
                        } catch (error) {
                            console.error("Error fetching models:", error);
                        }
                    }
                }, 200);
                setValue('background_denoising', aiagent.data.data.background_denoising);
                setValue('confidence_threshold', aiagent.data.data.confidence_threshold);
                setValue('use_numerals', aiagent.data.data.use_numerals);
                setValue('silence_duration', aiagent.data.data.silence_duration);
            }
        } catch (error) {
            console.error(error);
        }
    }

    const getAIAgentsbyIDSummar = async (id) => {
        try {
            let aiagent = await getAIAgentsbyIDSummary(id);
            if (aiagent.data) {
                setValue('summary', aiagent.data.data.summary)
                setValue('summary_request_timeout', aiagent.data.data.summary_request_timeout)
                setValue('minimum_number_of_messages_trigger', aiagent.data.data.minimum_number_of_messages_trigger)
                setValue('success_evaluation_prompt', aiagent.data.data.success_evaluation_prompt)
            }
        } catch (error) {
            console.error(error);
        }
    }
    const [customFunction, setcustomFunction] = useState([])
    const getAIAgentsbyIDpredefinded = async (id) => {
        try {
            let aiagent = await getAIAgentsbyIDPredefinedFunctions(id);
            if (aiagent.data) {
                console.log(aiagent.data.data.custom_function)
                setcustomFunction([...aiagent.data.data.custom_function])
                const customIds = aiagent.data.data.custom_function.map(func => func.id);
                setValue('connected_integrations', customIds);
                setValue('enable_end_call_function', aiagent.data.data.enable_end_call_function)
                setValue('dial_keypad', aiagent.data.data.dial_keypad)
                setValue('auto_meeting_scheduling', aiagent.data.data.auto_meeting_scheduling)
                setValue('call_back_function', aiagent.data.data.call_back_function)

            }
        } catch (error) {
            console.error(error);
        }
    }

    const getAIAgentsbyIDCall = async (id) => {
        try {
            let aiagent = await getAIAgentsbyIDCallPrivacy(id);
            if (aiagent.data) {
                setValue('hipaa_compliance', aiagent.data.data.hipaa_compliance)
                setValue('pci_compliance', aiagent.data.data.pci_compliance)
                setValue('audio_recording', aiagent.data.data.audio_recording)
                setValue('audio_recording_format', aiagent.data.data.audio_recording_format)
                setValue('wait_seconds', aiagent.data.data.wait_seconds)
                setValue('on_punctuation_seconds', aiagent.data.data.on_punctuation_seconds)
                setValue('on_number_seconds', aiagent.data.data.on_number_seconds)
                setValue('smart_end_pointing', aiagent.data.data.smart_end_pointing)
                setValue('silence_timeout', aiagent.data.data.silence_timeout)
                setValue('maximum_duration', aiagent.data.data.maximum_duration)


            }
        } catch (error) {
            console.error(error);
        }

    }
    useEffect(() => {
        // getFolderLists();
        getTranscriberProvidersAndModels();
        getLLMProvidersAndModels();
        getVoiceProvidersAndModels();
        // getLanguages()
        // getVoiceModels();
        //getTranscriberLanguageModels();
        if (!isupdate) {
            reset();
        }
    }, [])



    useEffect(() => {
        if (isupdate) {
            getAIAgents(agetid);
            getAIAgentsLLMData(agetid);
            getAIAgentsbyIDTranscr(agetid)
            getAIAgentsbyIDpredefinded(agetid)
            // getAIAgentsbyIDSummar(agetid)
            getAIAgentsbyIDCall(agetid);
        } else {
            reset();
            setstep(0)
        }
    }, [isupdate])

    const handleGenerateImage = async () => {
        try {
            if (!getValues('system_prompt') || getValues('system_prompt').trim() === '') {
                triggerAlert('error', '', 'System prompt is required to generate flowchart');
                return;
            }
            setLoading(true);
            const token = getOnlyToken();
            const systemPrompt = getValues('system_prompt');

            const payload = {
                prompt: systemPrompt
            };

            const config = {
                headers: { Authorization: `Bearer ${token}` }
            };

            const res = await axios.post("/api/agents/prompt-flowchart/generate/", payload, config);

            if (res.data) {
                setFlowchartHtml(res.data);
                // Trigger mermaid rendering after state update
                setTimeout(() => {
                    if (window.mermaid) {
                        window.mermaid.contentLoaded();
                    }
                }, 100);
                triggerAlert('success', '', 'Flowchart generated successfully!');
            }
        } catch (error) {
            console.error(error);
            triggerAlert('error', '', error.response?.data?.message || 'Failed to generate flowchart');
        } finally {
            setLoading(false);
        }
    }



    const submitFolder = async (data) => {
        const response = await SaveFolderName(data);
        const respdata = response.data;
        if (respdata.status_code == 200) {
            sethide(false)
        }
    }

    const handleFileChange = (event) => {
        const files = event.target.files;
        const fileslist = Array.from(event.target.files);
        const results = [];
        let loadedCount = 0;

        if (!files || files.length === 0) return;
        const oversizedFiles = fileslist.filter(file => file.size > MAX_FILE_SIZE);
        if (oversizedFiles.length > 0) {
            triggerAlert('error', '', `Each file must be under 1MB. Oversized: ${oversizedFiles.map(f => f.name).join(', ')}` || 'Something went wrong');

            event.target.value = '';
            setFileDataArray([]);
            return;
        }
        Array.from(files).forEach((file) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                results.push({
                    base64: reader.result,
                    name: file.name,
                    type: file.type,
                });

                loadedCount++;
                if (loadedCount === files.length) {
                    setFileDataArray(results);
                }
            };
        });
    };
    const allowedTypes = [
        "image/jpeg",
        "image/png",
        "image/gif",
        "image/webp",
        "image/bmp",
        "image/svg+xml"
    ];
    const handleFileChangePrfile = (event) => {
        const files = event.target.files;
        if (!files || files.length === 0) return;

        const fileList = Array.from(files);
        const MAX_FILE_SIZE = 1024 * 1024; // 1MB
        const results = [];
        let loadedCount = 0;
        const invalidFiles = fileList.filter(file => !allowedTypes.includes(file.type));
        if (invalidFiles.length > 0) {
            triggerAlert('error', "", `Only image files are allowed. Invalid: ${invalidFiles.map(f => f.name).join(', ')}`);
            event.target.value = '';
            setFileDataArray2([]);
            return;
        }
        // Check for non-image files
        const nonImageFiles = fileList.filter(file => !file.type.startsWith("image/"));
        if (nonImageFiles.length > 0) {
            triggerAlert('error', "", `Only image files are allowed. Invalid: ${nonImageFiles.map(f => f.name).join(', ')}`);
            event.target.value = '';
            setFileDataArray2([]);
            return;
        }

        // Check for oversized files
        const oversizedFiles = fileList.filter(file => file.size > MAX_FILE_SIZE);
        if (oversizedFiles.length > 0) {
            triggerAlert(
                'error',
                '',
                `Each file must be under 1MB. Oversized: ${oversizedFiles.map(f => f.name).join(', ')}` || 'Something went wrong'
            );
            event.target.value = '';
            setFileDataArray2([]);
            return;
        }

        // Convert valid images to base64
        fileList.forEach((file) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                results.push({
                    base64: reader.result,
                    name: file.name,
                    type: file.type,
                });

                loadedCount++;
                if (loadedCount === fileList.length) {
                    setFileDataArray2(results);
                }
            };
        });
    };

    const handleFlowlist = async (id, agentType) => {
        try {
            const token = getOnlyToken();
            const config = {
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                }
            }
            const payload = {
                id: flowID,
                flow_type: agentType,
                agent: id
            }
            const response = await axios.post('/api/admin/default_agent_flow/save/', payload, config);

            if (response.status === 200 || response.status === 201) {
                goToNextStep();
            }
        } catch (error) {
            console.error('Error creating agent flow:', error);
            triggerAlert('error', '', error.response?.data?.message || 'Failed to create agent flow');
        } finally {
            setdisabled(false);
        }
    }


    const submit = async (data, isAdvancedSettings = false) => {

        // Common helper for handling API calls
        const handleStep = async (apiFunc, payload, onSuccess) => {
            try {
                let response = await apiFunc(payload);
                setdisabled(false);
                if (isAdvancedSettings == false) {
                    if (response.data && [200, 201].includes(response.data.status_code)) {
                        triggerAlert('success', '', response.data.message || 'Something went wrong');
                        onSuccess(response.data);
                    }
                }
            } catch (error) {
                setdisabled(false);
                triggerAlert('error', '', error.response?.data?.message || 'Something went wrong');
                console.error(error);
            }
        };

        if (step === 0) {
            // Save Step 0 data to state
            console.log('Step 0 data:', data); // Debug log
            setStep0Data(data);
            setstep(step + 1);
        }
        if (step === 1) {
            console.log('Step 1 data:', data); // Debug log
            // Save Step 1 data to state
            setStep1Data(data);
            setstep(step + 1);
        }

        if (step === 2) {
            setdisabled(true);
            // Build request using dynamic data from Step 0 and Step 1
            let request = {
                // Data from Step 0 (Profile)
                ...(agetid && agetid !== "null" ? { agent_id: agetid } : {}),

                agent_name: step0Data.agent_name,
                agent_position: step0Data.agent_position || "",
                goal: step0Data.goal || "",
                language: step0Data.language_agent || "",
                gender: step0Data.gender || "",
                voice_code: step0Data.voice_code || "",
                language_code: languageCode || "",
                voice_provider: step0Data.voice_provider,
                agent_type: step0Data.agent_type,
                pack_price: step0Data.pack_price !== undefined && step0Data.pack_price !== '' && step0Data.pack_price !== null ? parseFloat(step0Data.pack_price) : null,
                pack_units: step0Data.pack_units !== undefined && step0Data.pack_units !== '' && step0Data.pack_units !== null ? parseFloat(step0Data.pack_units) : null,
                html: flowchartHtml || "",
                // Data from Step 1 (Company Description)
                // company_name: step1Data.agent_company_name || "",
                // about_the_company: step1Data.about_the_company || "",
                // company_website: step1Data.agent_company_website || "",
                // additional_info: step1Data.additional_information || "",

                // Additional fields
                // user_ids: step1Data.connected_integrations || "",
                integrations: step1Data.connected_integrations,
                system_prompt: data.system_prompt || "",
                first_message: step1Data.first_message || "",
                ...(profilePictureAgentTypes.includes(step0Data.agent_type) && fileDataArray2.length > 0 && fileDataArray2[0].base64
                    ? { profile_picture: fileDataArray2[0].base64 }
                    : {})
            };

            await handleStep(CreateAgentBasic, request, (response) => {
                setdisabled(false);
                // navigate('/agentslist');
                setPromptMode(null)
                // goToNextStep();
                if (response.status_code === 201 || response.status_code === 200) {
                    console.log(agentType, "agentType")
                    if (isAdvancedSettings === true) {
                        setstep(step + 1);
                    } else {
                        navigate('/configurations/agentconfigurations');
                    }
                    //handleFlowlist(response.data.agent_id)
                }

            });
        }

        if (step === 3) {
            setdisabled(true);
            let request = {
                agent_id: agentID || agetid,
                transcriber_provider: data.transcriber_provider,
                language: data.language,
                model: data.model,
                background_denoising: data.background_denoising ?? false,
                confidence_threshold: data.confidence_threshold,
                use_numerals: data.use_numerals ?? false,
                silence_duration: data.silence_duration
            };

            await handleStep(TranscriberProviderAPI, request, () => {
                setstep(step + 1);
            });
        }

        if (step === 4) {
            let request = {
                agent_id: agentID || agetid,
                enable_end_call_function: data.enable_end_call_function ?? false,
                dial_keypad: data.dial_keypad ?? false,
                auto_meeting_scheduling: data.auto_meeting_scheduling ?? false,
                call_back_function: data.call_back_function ?? false,
            };

            await handleStep(PredefinedFunctionsAPI, request, () => {
                setstep(step + 1); // Skip step 4 and go directly to step 5
            });
        }

        // if (step === 4) {
        //     let request = {
        //         agent_id: agentID || agetid,
        //         summary: data.summary,
        //         summary_request_timeout: data.summary_request_timeout,
        //         minimum_number_of_messages_trigger: data.minimum_number_of_messages_trigger,
        //         success_evaluation_prompt: data.success_evaluation_prompt,
        //     };

        //     await handleStep(AgentSummaryAPI, request, () => {
        //         setstep(step + 1);
        //     });
        // }

        if (step === 5) {
            let request = {
                agent_id: agentID || agetid,
                hipaa_compliance: data.hipaa_compliance ?? false,
                pci_compliance: data.pci_compliance ?? false,
                audio_recording: data.audio_recording ?? false,
                audio_recording_format: data.audio_recording_format,
                wait_seconds: data.wait_seconds,
                on_punctuation_seconds: data.on_punctuation_seconds,
                on_number_seconds: data.on_number_seconds,
                smart_end_pointing: data.smart_end_pointing,
                silence_timeout: data.silence_timeout,
                maximum_duration: data.maximum_duration
            };

            await handleStep(CallPrivacyAPI, request, () => {
                naviation('/configurations/agentconfigurations');
                // goToNextStep()
            });
        }
    };


    const [loading, setLoading] = useState(false);
    const handleGenerateInfo = async () => {
        const companyName = getValues("agent_company_name");
        const companyWebsite = getValues("agent_company_website");

        if (!companyName || !companyWebsite) {
            setErrorMessage("Please fill in Company Name and Company Website before generating info.");
            setErrorModal(true);
            return;
        }

        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };

        try {
            setLoading(true);

            const response = await axios.post(
                `/api/agents/company-info-gen/`,
                {
                    company_name: companyName,
                    company_website: companyWebsite,
                },
                config
            );
            const companyInfo = response.data?.Company_info?.[0]?.company_info;

            if (companyInfo) {
                setValue("about_the_company", companyInfo);
            } else {
                alert("No company info found in the response.");
            }
        } catch (error) {
            console.error("Error generating company info:", error);
            alert("Failed to generate company info. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    const [personaModels, setPersonaModels] = useState([]);
    const [selectedId, setSelectedId] = useState(null);


    const fetchSystemPromptModels = async (filterType = "all", agentType = "", searchQuery = "") => {
        setPerLoading(true);
        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };
        try {
            // Build query parameters conditionally
            let isDefault = "";
            let isAiGenerated = "";
            let firstParam = true;

            if (filterType === "business") {
                isDefault = "?is_default=true";
                firstParam = false;
            } else if (filterType === "creative") {
                isAiGenerated = "?is_ai_generated=true";
                firstParam = false;
            } else if (filterType === "custom") {
                isAiGenerated = "?is_ai_generated=false";
                firstParam = false;
            }

            const res = await axios.get(
                `/api/agents/default-prompt/list/` +
                `${isDefault}` +
                `${isAiGenerated}` +
                `${agentType && agentType !== " " ? `${firstParam && !isDefault && !isAiGenerated ? "?" : "&"}agent_type=${agentType}` : ""}` +
                `${searchQuery.trim() ? `${firstParam && !isDefault && !isAiGenerated && (!agentType || agentType === " ") ? "?" : "&"}search=${searchQuery}` : ""}`,
                config
            );

            if (res.data && res.data.status === 200) {
                const PromptDataid = res.data.data.find(
                    (item) => item.prompt_id === "prompt_id"
                );
                if (PromptDataid) {
                    setValue1("prompt_id", PromptDataid.prompt_id);
                }
            }
            setPersonaModels(res.data.data || []);

        } catch (error) {
            console.error("Error fetching system prompt:", error);
            triggerAlert('error', '', error.response?.data?.message || 'Failed to fetch templates');
            setPersonaModels([]);
        } finally {
            setPerLoading(false);
        }
    };

    const handleSelect1 = (id) => {
        setSelectedId(id);
    };

    const clearSelection = () => {
        setSelectedId(null);
    };
    // useEffect(() => {
    //     if (customFunction.length > 0) {
    //         setIntegrationOptions(customFunction.map(func => ({
    //             value: func.id,
    //             label: func.function_name
    //         })));

    //         // Re-map integrations if in edit mode
    //         if (isupdate) {
    //             const currentIntegrations = getValues("connected_integrations");
    //             if (currentIntegrations && Array.isArray(currentIntegrations) && typeof currentIntegrations[0] === 'string') {
    //                 const integrationIds = currentIntegrations.map(funcName => {
    //                     const func = customFunction.find(cf => cf.function_name === funcName);
    //                     return func ? func.id : null;
    //                 }).filter(id => id !== null);
    //                 setValue("connected_integrations", integrationIds);
    //             }
    //         }
    //     }
    // }, [customFunction])

    // fetchSystemPrompt();
    // getVoiceModels();

    const handleCustfuncDelete =(cust) =>{
     ConfirmationAlert(
          `Are you sure you want to delete "${cust.function_name}"!`,
          'Yes, delete it!',
          () => handleDeleteConfirm(cust.id)
        );
}

 const handleDeleteConfirm = async (id) => {
    const token = getOnlyToken();
    setLoading(true);
    try {
      const config = { headers: { Authorization: `Bearer ${token}` } };
      await axios.delete(`api/agents/custom-functions/${id}/`, config);
      await getAIAgentsbyIDpredefinded(agetid);
      fetchIntegrations();
      setSuccessMessage("Custom function deleted successfully");
      setShowSuccessModal(true);
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Failed to delete Custom Function");
      setErrorModal(true);
    } finally {
      setLoading(false);
    }
  }
    const [requestParams, setrequestParams] = useState([{ name: "", type: "", description: "" }])
    const [openModal, setOpenModal] = useState(false)
    const [editcustomFunctionDataID, seteditcustomFunctionDataID] = useState()
    const [successModal, setSuccessModal] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [successTitle, setSuccessTitle] = useState("");
    const [integrations, setIntegrations] = useState([]);
    const [integrationOptions, setIntegrationOptions] = useState([]);
    const [allIntegrations, setAllIntegrations] = useState([]);

    const CheckboxOption = (props) => (
        <div
            className="d-flex align-items-center px-2 py-1"
            onClick={() => props.selectOption(props.data)}
            style={{ cursor: 'pointer' }}
        >
            <input
                type="checkbox"
                checked={props.isSelected}
                readOnly
                className="form-check-input me-2"
            />
            <label className="mb-0 form-check-label" style={{ cursor: 'pointer' }}>{props.label}</label>
        </div>
    );
    const handleClose = () => {
        setOpenModal(false);
        seteditcustomFunctionDataID(null);
    };
    const [errorForParams, seterrorForParams] = useState();
    const onSubmit = async (data) => {
        data.agent_id = agentID || agetid;
        console.log(data)

        const token = getOnlyToken();
        const config = {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        };
        let errors = 0
        requestParams.map((params, i) => {
            if (!params.name || !params.description || !params.type) {
                errors = errors + 1
            }
        });

        if (errors !== 0) {
            seterrorForParams("Please enter all details in params")
            return false
        }
        data.parameters = requestParams;
        const headersObj = {};
        headers.forEach(header => {
            if (header.key && header.value) {
                headersObj[header.key] = header.value;
            }
        });
        data.headers = headersObj;
        setCustomFunctionLoading(true);

        if (editcustomFunctionDataID) {
            try {
                const res = await axios.patch(`/api/agents/custom-functions/${editcustomFunctionDataID}/`, data, config);
                if (res.data) {
                    setOpenModal(false);
                    setSuccessTitle("Custom Function Updated");
                    setSuccessMessage(`${data.function_name} has been successfully updated.`);
                    setSuccessModal(true);
                    setTimeout(() => {
                        setSuccessModal(false);
                        getAIAgentsbyIDpredefinded(agetid);
                        fetchIntegrations()
                        seteditcustomFunctionDataID(null);
                        setrequestParams([{ name: "", type: "", description: "" }]);
                    }, 2000);
                }
            } catch (error) {
                console.error("Error updating custom function:", error);
                setOpenModal(false);
                setErrorMessage(error.response?.data?.message || 'Failed to update custom function');
                setErrorModal(true);
            } finally {
                setCustomFunctionLoading(false);
            }
        } else {
            try {
                const res = await axios.post(`/api/agents/custom-functions/`, data, config);
                if (res.data) {
                    setOpenModal(false);
                    setSuccessTitle("Custom Function Created");
                    setSuccessMessage(`${data.function_name} has been successfully created.`);
                    setSuccessModal(true);
                    setTimeout(() => {
                        setSuccessModal(false);
                        getAIAgentsbyIDpredefinded(agetid);
                        fetchIntegrations()
                        setrequestParams([{ name: "", type: "", description: "" }]);
                    }, 2000);
                }
            } catch (error) {
                console.error("Error creating custom function:", error);
                setOpenModal(false);
                setErrorMessage(error.response?.data?.message || 'Failed to create custom function');
                setErrorModal(true);
            } finally {
                setCustomFunctionLoading(false);
            }
        }
    }
    const AddNewHeader = () => {
        let headerList = headers;
        let object = { key: "", value: "" };
        headerList.push(object)
        setHeaders([...headerList])
    }

    const AddNewParamsToDist = () => {
        let requestParam = requestParams;
        let object = { name: "", type: "", description: "" };
        requestParam.push(object)
        setrequestParams([...requestParam])
    }
    const removeRequestParam = (index) => {
        const params = [...requestParams];
        if (index >= 0 && index < params.length) {
            params.splice(index, 1);
            setrequestParams(params);
        }
    }
    const removeHeader = (index) => {
        const headerList = [...headers];
        if (index >= 0 && index < headerList.length) {
            headerList.splice(index, 1);
            setHeaders(headerList);
        }
    }
    const changeParameterNameandLabel = (value, number, type) => {
        seterrorForParams("")
        let requestParam = requestParams;
        if (type == "name") {
            requestParam[number].name = value
        }
        if (type == "type") {
            requestParam[number].type = value
        }
        if (type == "description") {
            requestParam[number].description = value
        }
        if (type == "required") {
            requestParam[number].required = value
        }

        setrequestParams([...requestParam])

    }
    const changeHeaderKeyValue = (value, number, type) => {
        let headerList = headers;
        if (type == "key") {
            headerList[number].key = value
        }
        if (type == "value") {
            headerList[number].value = value
        }
        setHeaders([...headerList])
    }
    const onloadDatatoModel = (data) => {
        setValue3("function_name", data.function_name)
        setValue3("function_description", data.function_description)
        setValue3("url", data.url)
        setValue3("url_type", data.url_type)
        setValue3("data_type", data.data_type)
        seteditcustomFunctionDataID(data.id)
        setrequestParams(data.parameters || [{ name: "", type: "", description: "" }])
        if (data.headers && typeof data.headers === 'object' && Object.keys(data.headers).length > 0) {
            setHeaders(Object.entries(data.headers).map(([key, value]) => ({ key, value })))
        } else {
            setHeaders([{ key: "", value: "" }])
        }

    }
    useEffect(() => {
        fetchSystemPromptModels(selectedFilter, selectedType, searchFilter)
    }, [])



    useEffect(() => {
        const delayDebounce = setTimeout(() => {
            fetchSystemPromptModels(selectedFilter, selectedType, searchFilter);
        }, 500);

        return () => clearTimeout(delayDebounce);
    }, [searchFilter]);


    const FIRST_ROW = 4;
    const SECOND_ROW = 3;
    const TOTAL_VISIBLE = FIRST_ROW + SECOND_ROW;

    const handleSelect = (id) => {
        setSelectedId(id);
        setPromptMode("custom");
        setValue("prompt_id", id);
        clearErrors("prompt_id");
        setFlowchartHtml("");

        // Find the selected prompt and assign it to system_prompt
        const selectedPrompt = personaModels.find(prompt => prompt.prompt_id === id);
        if (selectedPrompt && selectedPrompt.prompt) {
            setValue("system_prompt", selectedPrompt.prompt);
            setcusModal(false);
        }
    };







    const handleFilterChange = (filterId) => {
        setSelectedFilter(filterId);
        // Fetch templates with the selected filter, current agent type, and search query
        fetchSystemPromptModels(filterId, selectedType, searchFilter);
    };

    console.log(advancedSettings, 'sasassa')




    return (
        <>

            <div id='layout-wrapper'>
                <Header />
                <Sidebar />
                <div className='page-content'>

                    <div className="main-content">
                        {(loading) && (
                            <div className="full-page-loader-overlay">
                                <Loader />
                            </div>
                        )}

                        {aiLoading && (
                            <div className="full-page-loader-overlay">
                                <Loader />
                                {/* <AILoader/> */}
                            </div>
                        )}
                        <div className="  ">


                            {/* <h4 className="fs-3 fw-bold py-2 text-primary ">Agent-Creation</h4> */}
                            <div class="page-title-box d-flex justify-content-between align-items-center"><h4 class="page-title mb-0">{isupdate ? "Update Agent" : "Create Agent"}</h4><a class="btn btn-md btn-primary" onClick={() => navigate("/configurations/agentconfigurations")} data-discover="true">Back <i class="x-heroicon-o-folder ms-1"></i></a></div>

                            <div className="row">

                                <div className={`col-md-12 `}>

                                    <div className=" border border-0   mb-0 ">
                                        <div className="row ">
                                            <div className='d-flex justify-content-end align-items-center px-2'>

                                                {/* {isupdate &&
                                        <div className="d-flex justify-content-center ">
                                            <svg width="50" height="50">
                                                <circle cx="25" cy="25" r="20" fill="none" stroke="#e9ecef" strokeWidth="4" />
                                                <circle cx="25" cy="25" r="20" fill="none" stroke="#05a165" strokeWidth="4" strokeDasharray={`${2 * Math.PI * 20}`} strokeDashoffset={`${2 * Math.PI * 20 * (1 - (step + 1) / 6)}`} strokeLinecap="round" transform="rotate(-90 25 25)" />
                                                <text x="25" y="30" textAnchor="middle" fontSize="12" fill="#05a165">{Math.round(((step + 1) / 6) * 100)}%</text>
                                            </svg>
                                        </div>} */}
                                            </div>
                                        </div>
                                        <form id="msform" onSubmit={handleSubmit((data) => submit(data, false))} action={"#"} className="form-horizontal">

                                            {/* ================= STEPPER - Exact Image Design ================= */}
                                            {(
                                                <Paper sx={{ mb: 3 }}>
                                                    <Tabs
                                                        value={step}
                                                        onChange={(_, newValue) => setstep(newValue)}
                                                        sx={{
                                                            borderBottom: 1,
                                                            borderColor: 'divider',
                                                            backgroundColor: '#ffffff'
                                                        }}
                                                        variant="fullWidth"

                                                        scrollButtons="auto"
                                                    >
                                                        {steps.map((stepItem, index) => (
                                                            <Tooltip key={stepItem.id} title={stepItem.tooltip || stepItem.label} arrow placement="top">
                                                                <Tab
                                                                    label={
                                                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                                                            <Chip
                                                                                label={index + 1}
                                                                                size="small"
                                                                                sx={{
                                                                                    bgcolor: step >= stepItem.id ? '#014670' : '#adb5bd',
                                                                                    color: 'white',
                                                                                    fontWeight: 600,
                                                                                    fontSize: '0.75rem'
                                                                                }}
                                                                            />
                                                                            {stepItem.icon && (
                                                                                <i
                                                                                    className={`bi ${stepItem.icon}`}
                                                                                    style={{
                                                                                        fontSize: "20px",
                                                                                        color: step === stepItem.id ? "#1976D2" : "#6c757d",
                                                                                    }}
                                                                                />
                                                                            )}
                                                                            <span style={{
                                                                                color: step === stepItem.id ? "#1976D2" : "#6c757d",
                                                                                fontWeight: 500,
                                                                            }} >{stepItem.label}</span>
                                                                        </Box>
                                                                    }
                                                                    disabled={step < stepItem.id}
                                                                />
                                                            </Tooltip>
                                                        ))}
                                                    </Tabs>
                                                </Paper>
                                            )}


                                            <div className=' '>
                                                <fieldset className={step == 0 ? "active" : ""}>
                                                    <div className="form-card">

                                                        {/* BLOCK 1: BASIC AGENT INFORMATION */}
                                                        <div className="p-4 mb-4 bg-white border  rounded-3">
                                                            <h5 className="mb-4 text-dark fw-bold d-flex align-items-center">
                                                                <i className="bi bi-person-circle me-2" style={{ color: '#014670' }}></i>Basic Agent Information
                                                                <Tooltip title="Agent name, role, and purpose description" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 16, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                                </Tooltip>
                                                            </h5>
                                                            <div className="row g-3">
                                                                <div className="col-md-6">
                                                                    <div className="row g-3 h-100">
                                                                        <div className="col-md-12">
                                                                            <label htmlFor="AgentName" className="form-label">
                                                                                Agent Name <span className='text-danger'>*</span> :
                                                                                <Tooltip title="Enter a unique name for your AI agent (e.g., 'Sales Bot', 'Support Agent')" arrow placement="top">
                                                                                    <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                                </Tooltip>
                                                                            </label>
                                                                            <input type="text" className="form-control" id="AgentName" {...register("agent_name", { required: step == 0 ? { value: true, message: "Agent Name is required" } : false, })} placeholder="Enter Agent Name" onKeyUp={() => trigger("agent_name")} />
                                                                            {errors.agent_name && <p className='text-danger'>{errors.agent_name.message}</p>}
                                                                        </div>

                                                                        <div className="col-md-6">
                                                                            <label htmlFor="AgentPosition" className="form-label">
                                                                                Agent Role <span className='text-danger'>*</span>:
                                                                                <Tooltip title="Define the role or position of your agent (e.g., 'Sales Representative', 'Customer Support Specialist')" arrow placement="top">
                                                                                    <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                                </Tooltip>
                                                                            </label>
                                                                            <input type="text" className="form-control" id="AgentPosition"  {...register("agent_position", { required: step == 0 ? { value: true, message: "Agent Position is required" } : false, })} placeholder="Describe the agent's role (e.g., Sales Representative, Customer Support)" onKeyUp={() => trigger("agent_position")} />
                                                                            {errors.agent_position && <p className='text-danger'>{errors.agent_position.message}</p>}
                                                                        </div>
                                                                        <div className="col-md-6">
                                                                            <label htmlFor="AgentType" className="form-label">
                                                                                Agent Type <span className='text-danger'>*</span>:
                                                                                <Tooltip title="Select the type of agent you want to create (Inbound, Outbound, or Both)" arrow placement="top">
                                                                                    <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                                </Tooltip>
                                                                            </label>
                                                                            <select id="AgentType" className="form-select"  {...register("agent_type", { required: { value: true, message: "Agent Type is required" } })}>
                                                                                <option value=""> -- Select Agent Type --</option>
                                                                                <option value="in-bound">Inbound</option>
                                                                                <option value="out-bound"> Outbound</option>
                                                                                <option value="both"> Both</option>
                                                                            </select>
                                                                            {errors.agent_type && <p className='text-danger'>{errors.agent_type.message}</p>}
                                                                        </div>

                                                                        {/* PROFILE PICTURE UPLOAD - shown for Outbound only */}
                                                                        {profilePictureAgentTypes.includes(selectedAgentType) && (
                                                                            <div className="col-md-12 mt-3">
                                                                                <label className="form-label">
                                                                                    Profile Picture :
                                                                                    <Tooltip title="Upload a profile picture for this agent (max 1MB, image files only)" arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                                    </Tooltip>
                                                                                </label>
                                                                                <div className="d-flex align-items-start gap-3 flex-wrap">
                                                                                    <div>
                                                                                        <input
                                                                                            type="file"
                                                                                            id="ProfilePicUpload"
                                                                                            accept="image/*"
                                                                                            style={{ display: 'none' }}
                                                                                            onChange={handleFileChangePrfile}
                                                                                        />
                                                                                        <div
                                                                                            className="d-flex align-items-stretch"
                                                                                            style={{
                                                                                                maxWidth: '300px',
                                                                                                border: '1px solid #ced4da',
                                                                                                borderRadius: '0.375rem',
                                                                                                overflow: 'hidden',
                                                                                                background: '#fff'
                                                                                            }}
                                                                                        >
                                                                                            <label
                                                                                                htmlFor="ProfilePicUpload"
                                                                                                className="mb-0 px-3 py-1"
                                                                                                style={{
                                                                                                    cursor: 'pointer',
                                                                                                    background: '#e9ecef',
                                                                                                    borderRight: '1px solid #ced4da',
                                                                                                    whiteSpace: 'nowrap',
                                                                                                    display: 'flex',
                                                                                                    alignItems: 'center'
                                                                                                }}
                                                                                            >
                                                                                                Choose File
                                                                                            </label>
                                                                                            <span
                                                                                                className="px-2 py-1 text-truncate flex-grow-1"
                                                                                                title={fileDataArray2[0]?.name || ''}
                                                                                                style={{
                                                                                                    minWidth: 0,
                                                                                                    color: fileDataArray2[0]?.name ? '#212529' : '#6c757d',
                                                                                                    display: 'flex',
                                                                                                    alignItems: 'center'
                                                                                                }}
                                                                                            >
                                                                                                {fileDataArray2[0]?.name || 'No file chosen'}
                                                                                            </span>
                                                                                        </div>
                                                                                        <small className="text-muted d-block mt-1">Accepted: JPG, PNG, GIF, WEBP, BMP, SVG &bull; Max size: 1MB</small>
                                                                                    </div>
                                                                                    {fileDataArray2.length > 0 && (
                                                                                        <div className="position-relative" style={{ width: '72px', height: '72px' }}>
                                                                                            <img
                                                                                                src={fileDataArray2[0].base64 || fileDataArray2[0].url}
                                                                                                alt="Profile Preview"
                                                                                                style={{
                                                                                                    width: '72px',
                                                                                                    height: '72px',
                                                                                                    objectFit: 'cover',
                                                                                                    borderRadius: '50%',
                                                                                                    border: '2px solid #014670'
                                                                                                }}
                                                                                            />
                                                                                            <button
                                                                                                type="button"
                                                                                                title="Remove"
                                                                                                onClick={() => setFileDataArray2([])}
                                                                                                style={{
                                                                                                    position: 'absolute',
                                                                                                    top: '-6px',
                                                                                                    right: '-6px',
                                                                                                    width: '20px',
                                                                                                    height: '20px',
                                                                                                    borderRadius: '50%',
                                                                                                    border: 'none',
                                                                                                    background: '#dc3545',
                                                                                                    color: '#fff',
                                                                                                    fontSize: '12px',
                                                                                                    lineHeight: 1,
                                                                                                    cursor: 'pointer',
                                                                                                    display: 'flex',
                                                                                                    alignItems: 'center',
                                                                                                    justifyContent: 'center'
                                                                                                }}
                                                                                            >
                                                                                                &times;
                                                                                            </button>
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                    </div>
                                                                </div>

                                                                <div className="col-md-6">
                                                                    <label htmlFor="CallingAgent" className="form-label">
                                                                        Description <span className='text-danger'>*</span>:
                                                                        <Tooltip title="Provide a detailed description of your agent's purpose and what it should accomplish (e.g., 'The agent has to sell digital marketing services to other companies')" arrow placement="top">
                                                                            <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                        </Tooltip>
                                                                    </label>
                                                                    <textarea className="form-control" id="CallingAgent"  {...register("goal", { required: step == 0 ? { value: true, message: "Goal for Calling Agent is required" } : false })} rows="6" placeholder="Describe the goal of your agent (e.g., the agent has to sell digital marketing services to other companies)"></textarea>
                                                                    {errors.goal && <p className='text-danger'>{errors.goal.message}</p>}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* BLOCK 2: BILLING & PRICING */}
                                                        <div className="p-4 mb-4 bg-white border rounded-3">
                                                            <h5 className="mb-4 text-dark fw-bold d-flex align-items-center">
                                                                <i className="bi bi-currency-dollar me-2" style={{ color: '#014670' }}></i>Billing & Pricing
                                                                <Tooltip title="Agent price and pack duration" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 16, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                                </Tooltip>
                                                            </h5>
                                                            <div className="row g-3">
                                                                <div className="col-md-6">
                                                                    <label htmlFor="AgentPrice" className="form-label">
                                                                        Agent Price <span className='text-danger'>*</span>:
                                                                        <Tooltip title="Price per pack (e.g., 59.00)" arrow placement="top">
                                                                            <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                        </Tooltip>
                                                                    </label>
                                                                    <input
                                                                        type="number"
                                                                        step="0.01"
                                                                        min="0"
                                                                        className="form-control"
                                                                        id="AgentPrice"
                                                                        placeholder="e.g., 59.00"
                                                                        {...register("pack_price", {
                                                                            required: step == 0 ? { value: true, message: "Agent Price is required" } : false,
                                                                            min: { value: 0, message: "Agent Price must be 0 or greater" }
                                                                        })}
                                                                        onKeyUp={() => trigger("pack_price")}
                                                                    />
                                                                    {errors.pack_price && <p className='text-danger'>{errors.pack_price.message}</p>}
                                                                </div>
                                                                <div className="col-md-6">
                                                                    <label htmlFor="PackUnits" className="form-label">
                                                                        Duration ({watch("unit_label") || "mins"}) <span className='text-danger'>*</span>:
                                                                        <Tooltip title="Number of units included in the pack (e.g., 100)" arrow placement="top">
                                                                            <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                        </Tooltip>
                                                                    </label>
                                                                    <input
                                                                        type="number"
                                                                        step="0.01"
                                                                        min="0"
                                                                        className="form-control"
                                                                        id="PackUnits"
                                                                        placeholder="e.g., 100"
                                                                        {...register("pack_units", {
                                                                            required: step == 0 ? { value: true, message: "Duration is required" } : false,
                                                                            min: { value: 0, message: "Duration must be 0 or greater" }
                                                                        })}
                                                                        onKeyUp={() => trigger("pack_units")}
                                                                    />
                                                                    {errors.pack_units && <p className='text-danger'>{errors.pack_units.message}</p>}
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {/* BLOCK 3: LANGUAGE & VOICE CONFIGURATION */}
                                                        <div className="p-4 mb-4 bg-white border rounded-3">
                                                            <h5 className="mb-4 text-dark fw-bold d-flex align-items-center">
                                                                <i className="bi bi-mic-fill me-2" style={{ color: '#014670' }}></i>Language & Voice Configuration
                                                                <Tooltip title="Language, voice type, and voice model selection" arrow placement="top">
                                                                    <InfoOutlined sx={{ fontSize: 16, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                                </Tooltip>
                                                            </h5>
                                                            <div className="row g-3">
                                                                <div className="mb-1 col-md-4">
                                                                    <label htmlFor="Voice2" className="form-label">
                                                                        Select  Voice Provider<span className='text-danger'>*</span>:
                                                                        <Tooltip title="Select the voice provider for your agent" arrow placement="top">
                                                                            <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                        </Tooltip>
                                                                    </label>
                                                                    <select
                                                                        id="Voice2"
                                                                        className="form-select"
                                                                        {...register("voice_provider", {
                                                                            required: step == 0 ? { value: true, message: "Voice Provider is required" } : false
                                                                        })}
                                                                    >
                                                                        <option value="">-- Choose Provider --</option>
                                                                        {VoiceprovidersModels.map((provider) => (
                                                                            <option value={provider.name} key={provider.id}>
                                                                                {provider.name}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    {errors.voice_provider && <p className="text-danger">{errors.voice_provider.message}</p>}


                                                                </div>
                                                                <div className="col-md-4">
                                                                    <label htmlFor="selectFolder" className="form-label">
                                                                        Language <span className='text-danger'>*</span>:
                                                                        <Tooltip title="Select the language your agent will communicate in" arrow placement="top">
                                                                            <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                        </Tooltip>
                                                                    </label>
                                                                    <select id="selectFolder" className="form-select" value={selectedLanguage || ''} {...register("language_agent", { required: { value: true, message: "Language is required" } })}>
                                                                        <option value=""> -- Select Language --</option>
                                                                        {languages?.map((lan, index) => (
                                                                            <option value={lan} key={index}>
                                                                                {lan}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    {errors.language_agent && <p className='text-danger'>{errors.language_agent.message}</p>}
                                                                </div>

                                                                <div className="col-md-3">
                                                                    <label className="form-label">
                                                                        Voice Type <span className='text-danger'>*</span>:
                                                                        <Tooltip title="Choose whether your agent's voice should be male or female" arrow placement="top">
                                                                            <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                        </Tooltip>
                                                                    </label>
                                                                    <div className="d-flex gap-4 align-items-center">
                                                                        <div className="form-check custom-radio">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="radio"
                                                                                id="genderMale"
                                                                                value="male"
                                                                                {...register("gender")}
                                                                            />
                                                                            <label className="form-check-label fw-medium" htmlFor="genderMale">
                                                                                Male
                                                                            </label>
                                                                        </div>

                                                                        <div className="form-check custom-radio">
                                                                            <input
                                                                                className="form-check-input"
                                                                                type="radio"
                                                                                id="genderFemale"
                                                                                value="female"
                                                                                {...register("gender")}
                                                                            />
                                                                            <label className="form-check-label fw-medium" htmlFor="genderFemale">
                                                                                Female
                                                                            </label>
                                                                        </div>
                                                                    </div>
                                                                    {errors.gender && <p className="text-danger">{errors.gender.message}</p>}
                                                                </div>


                                                                <div className="col-md-6">
                                                                    <label htmlFor="Voice2" className="form-label">
                                                                        Select AI Voice <span className='text-danger'>*</span>:
                                                                        <Tooltip title="Choose a specific voice model for your agent. Select a language and gender first." arrow placement="top">
                                                                            <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                        </Tooltip>
                                                                    </label>
                                                                    <select
                                                                        id="Voice2"
                                                                        className="form-select"
                                                                        {...register("voice_code", {
                                                                            required: step == 0 ? { value: true, message: "Voice Model is required" } : false
                                                                        })}
                                                                        disabled={!selectedLanguage || !selectedGender}
                                                                    >
                                                                        <option value="">-- Choose Model --</option>
                                                                        {voiceModels.map((provider, i) => (
                                                                            <option value={provider.voice_code} key={'VoiceModel' + i}>
                                                                                {provider.name == "cartesia" ? provider.name_of_voice : provider.voice_code}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                    {errors.voice_code && <p className="text-danger">{errors.voice_code.message}</p>}
                                                                </div>

                                                                <div className="col-md-6">
                                                                    {selectedVoiceAudio && (
                                                                        <div>
                                                                            <label htmlFor="Voice2" className="form-label">
                                                                                Voice Preview:
                                                                                <Tooltip title="Listen to a preview of the selected voice" arrow placement="top">
                                                                                    <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                                </Tooltip>
                                                                            </label>
                                                                            <div className="d-flex align-items-center gap-2">
                                                                                <audio
                                                                                    controls
                                                                                    preload="metadata"
                                                                                    style={{
                                                                                        width: '100%',
                                                                                        height: '40px'
                                                                                    }}
                                                                                    key={selectedVoiceAudio}
                                                                                >
                                                                                    <source src={selectedVoiceAudio} type="audio/wav" />
                                                                                    <source src={selectedVoiceAudio} type="audio/mpeg" />
                                                                                    Your browser does not support the audio element.
                                                                                </audio>
                                                                            </div>
                                                                            <small className="text-muted">
                                                                                Preview of selected AI Voice Model
                                                                            </small>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div className='d-flex justify-content-end gap-2'>
                                                        {/* {isupdate && <input type="button" name="next" className="btn btn-md btn-primary" value="Skip For Now" onClick={() => setstep(step + 1)} />} */}
                                                        {isupdate && <Button variant='outline-warning' onClick={() => {
                                                            const formData = getValues();
                                                            setStep0Data(formData);
                                                            setstep(step + 1);
                                                        }}>Skip for Now</Button>}
                                                        <button className="btn btn-md btn-secondary" type="button" disabled={disabled}
                                                            onClick={() => naviation('/agentslist')}>
                                                            Cancel
                                                        </button>

                                                        <button className="btn btn-md btn-primary" type="submit" disabled={disabled}>
                                                            {disabled ? <span className="spinner-border spinner-border-sm" role="status"  ></span> : ""}
                                                            {/* {isupdate ? 'Update Agent' : "Create Agent"} */}
                                                            Save and Continue

                                                        </button>

                                                    </div>


                                                </fieldset>
                                                <fieldset className={step == 1 ? "active" : ""}>
                                                    <div className="p-4 mb-4 bg-white border rounded-3">
                                                        <h5 className="mb-4 text-dark fw-bold d-flex align-items-center">
                                                            <i className="bi bi-chat-dots-fill me-2" style={{ color: '#014670' }}></i>Greeting Message & Integrations
                                                            <Tooltip title="Configure greeting message and integration settings" arrow placement="top">
                                                                <InfoOutlined sx={{ fontSize: 16, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                            </Tooltip>
                                                        </h5>
                                                        <div className="row g-3">
                                                            {/* <div className="mb-2 col-md-6">
                                                                <label htmlFor="CompanyName" className="form-label">
                                                                    Company Name : <span><i className="ri-information-line fs-16"></i></span>
                                                                </label>
                                                                <input type="text" className="form-control mt-2" id="CompanyName" {...register("agent_company_name", { required: step == 1 ? { value: true, message: "Company Name is required" } : false })} placeholder="Enter your Company Name" />
                                                                {errors.agent_company_name && <p className='text-danger'>{errors.agent_company_name.message}</p>}
                                                            </div>

                                                            <div className="mb-1 col-md-6">
                                                                <div className="d-flex gap-2 align-items-center mb-1 ">
                                                                    <label htmlFor="CompanyUrl" className="form-label">
                                                                        Company URL : <span><i className="ri-information-line fs-16"></i></span>
                                                                    </label>
                                                                    <button type="button" className="btn btn-sm btn-success rounded-pill ms-2 px-2 " onClick={() => { handleGenerateInfo() }}>Generate <i className="ri-sparkling-2-line fs-18 ms-1"></i></button>
                                                                </div>
                                                                <div className="input-group">
                                                                    <input type="text" className="form-control" id="CompanyUrl" {...register("agent_company_website", { required: step == 1 ? { value: true, message: "Company URL is required" } : false })} placeholder="https://example.com" />
                                                                </div>
                                                                {errors.agent_company_website && <p className='text-danger'>{errors.agent_company_website.message}</p>}
                                                            </div>

                                                            <div className="mb-1 col-md-12">
                                                                <label htmlFor="CompanyDescription" className="form-label">
                                                                    Company Description : <span><i className="ri-information-line fs-16"></i></span>
                                                                </label>
                                                                <textarea className="form-control" id="CompanyDescription" rows="4" style={{ minHeight: '200px' }} {...register("about_the_company", { required: step == 1 ? { value: true, message: "Company Description is required" } : false })} placeholder="Describe your company, products, and services..."></textarea>
                                                                {errors.about_the_company && <p className='text-danger'>{errors.about_the_company.message}</p>}
                                                            </div> */}
                                                            {/* LEFT COLUMN - GREETING MESSAGE */}
                                                            <div className="col-md-6">
                                                                <label htmlFor="GreetingMessage" className="form-label">
                                                                    Greeting Message <span className='text-danger'>*</span> :
                                                                    <Tooltip title="Enter the opening message your agent will use to greet callers (e.g., 'Hello! How can I help you today?')" arrow placement="top">
                                                                        <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                    </Tooltip>
                                                                </label>

                                                                <textarea
                                                                    type="text"
                                                                    className="form-control"
                                                                    id="GreetingMessage"
                                                                    placeholder="e.g., Hello! How can I help you today?"
                                                                    style={{ height: '180px', resize: 'none' }}
                                                                    {...register("first_message", {
                                                                        required: step == 1
                                                                            ? { value: true, message: "Greeting Message is required" }
                                                                            : false
                                                                    })}
                                                                />

                                                                {errors.first_message && (
                                                                    <p className="text-danger">
                                                                        {errors.first_message.message}
                                                                    </p>
                                                                )}
                                                            </div>

                                                            {/* RIGHT COLUMN - INTEGRATIONS & CUSTOM FUNCTIONS */}
                                                            <div className="col-md-6 d-flex flex-column">
                                                                {/* Connected Integrations */}
                                                                <div>
                                                                    <label htmlFor="ConnectedIntegrations" className="form-label">
                                                                        Connected Integrations :
                                                                        <Tooltip title="Select custom functions or integrations that your agent can use during conversations" arrow placement="top">
                                                                            <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                        </Tooltip>
                                                                    </label>

                                                                    <Controller
                                                                        name="connected_integrations"
                                                                        control={control}
                                                                        defaultValue={[]}
                                                                        render={({ field }) => (
                                                                            <Select
                                                                                options={integrationOptions}
                                                                                isMulti
                                                                                closeMenuOnSelect={false}
                                                                                hideSelectedOptions={false}
                                                                                components={{ Option: CheckboxOption }}
                                                                                placeholder="-- Select Integrations --"
                                                                                classNamePrefix="react-select"

                                                                                /* ✅ match selected options */
                                                                                value={integrationOptions.filter(
                                                                                    opt =>
                                                                                        Array.isArray(field.value) &&
                                                                                        field.value.includes(opt.value)
                                                                                )}


                                                                                onChange={(selected) => {
                                                                                    const selectedIds = selected ? selected.map(opt => opt.value) : [];
                                                                                    field.onChange(selectedIds);
                                                                                    const selectedFunctions = allIntegrations.filter(
                                                                                        integration => selectedIds.includes(integration.id)
                                                                                    );
                                                                                    setcustomFunction(selectedFunctions);
                                                                                }}

                                                                                styles={{
                                                                                    control: (base) => ({
                                                                                        ...base,
                                                                                        minHeight: '35px',
                                                                                        // padding: '4px 6px',       
                                                                                        borderRadius: '12px',
                                                                                    }),
                                                                                    valueContainer: (base) => ({
                                                                                        ...base,
                                                                                        padding: '6px 10px',
                                                                                    }),
                                                                                    input: (base) => ({
                                                                                        ...base,
                                                                                        margin: 0,
                                                                                        padding: 0,
                                                                                    }),
                                                                                    multiValue: (base) => ({
                                                                                        ...base,
                                                                                        borderRadius: '14px',
                                                                                        padding: '2px 4px',
                                                                                        backgroundColor: '#6888c5',
                                                                                        color: '#fff',
                                                                                    }),
                                                                                    multiValueLabel: (base) => ({
                                                                                        ...base,
                                                                                        color: '#fff',
                                                                                    }),
                                                                                    menu: (base) => ({
                                                                                        ...base,
                                                                                        marginTop: '6px',
                                                                                        borderRadius: '12px',
                                                                                        backgroundColor: '#ffffff',
                                                                                        boxShadow: '0 8px 24px rgba(0,0,0,0.08)',
                                                                                        border: '1px solid #dee2e6',
                                                                                    }),

                                                                                    menuList: (base) => ({
                                                                                        ...base,
                                                                                        padding: '6px',
                                                                                        maxHeight: '220px',
                                                                                        backgroundColor: '#cee0f0',
                                                                                    }),

                                                                                    /* Each option */
                                                                                    option: (base, state) => ({
                                                                                        ...base,
                                                                                        borderRadius: '8px',
                                                                                        padding: '10px 12px',
                                                                                        marginBottom: '2px',
                                                                                        backgroundColor: state.isSelected
                                                                                            ? '#0d6efd'
                                                                                            : state.isFocused
                                                                                                ? '#f1f5f9'
                                                                                                : 'transparent',
                                                                                        color: state.isSelected ? '#ffffff' : '#212529',
                                                                                        cursor: 'pointer',
                                                                                    }),
                                                                                }}
                                                                            />
                                                                        )}
                                                                    />
                                                                    {errors.connected_integrations && (
                                                                        <p className="text-danger">
                                                                            {errors.connected_integrations.message}
                                                                        </p>
                                                                    )}
                                                                </div>

                                                                {/* SPACER */}
                                                                <div className="mt-4"></div>

                                                                {/* Custom Functions */}
                                                                {/* <div className="d-flex justify-content-between align-items-center flex-wrap">
                                                                    <div>
                                                                        <h6 className="mb-1 fw-semibold">
                                                                            Custom Functions
                                                                        </h6>
                                                                        <p className="text-muted mb-0">
                                                                            Add custom API functions tailored to your specific needs.
                                                                        </p>
                                                                    </div>

                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-primary"
                                                                        onClick={() => {
                                                                            setOpenModal(true);
                                                                            reset3();
                                                                            setrequestParams([
                                                                                { name: "", type: "", description: "" }
                                                                            ]);
                                                                        }}
                                                                    >
                                                                        + Add Custom Function
                                                                    </button>
                                                                </div> */}

                                                            </div>

                                                            <div className="mb-1 col-md-12">
                                                                <label htmlFor="AdditionalInformation" className="form-label">
                                                                    Additional Information : <span><i className="ri-information-line fs-16"></i></span>
                                                                </label>
                                                                <textarea className="form-control" id="AdditionalInformation" rows="4" {...register("additional_information", { required: false })} placeholder="Any additional information about your company..."></textarea>
                                                            </div>


                                                            <div className='row'>
                                                                <div className='col-md-12'>
                                                                    <div className="d-flex justify-content-between align-items-center my-2 mt-3">
                                                                        <div>
                                                                            <h3 className="fs-20 fw-semibold mb-1">Custom Functions</h3>
                                                                            <p className="text-muted fs-13">Add custom API functions tailored to your specific needs.</p>
                                                                        </div>
                                                                           <button type="button" className="btn btn-sm btn-success" onClick={() => { setOpenModal(true); reset3(); seteditcustomFunctionDataID(null); setrequestParams([{ name: "", type: "", description: "" }]); setHeaders([{ key: "", value: "" }]) }}>+ Add Custom Function</button>
                                                                    </div>

                                                                </div>

                                                                <div className="mt-3">
                                                                    <div className="row mx-n1 g-0">
                                                                        {customFunction.map((custom, i) => {
                                                                            return (
                                                                                <div className="col-xxl-6 col-lg-6" key={i}>
                                                                                    <div className="card m-1 shadow-sm border" style={{ borderRadius: '10px', overflow: 'hidden' }}>
                                                                                        <div className="card-body p-3 position-relative">
                                                                                            <div className="d-flex justify-content-between align-items-start mb-2">
                                                                                                <h5 className="mb-0 fw-semibold" style={{ color: "#00FF9F" }}>{custom.function_name}</h5>
                                                                                                <div className="d-flex gap-1">
                                                                                                    <button type='button' className="btn btn-soft-primary btn-sm d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }} onClick={() => { setOpenModal(true); onloadDatatoModel(custom) }} title="Edit">
                                                                                                        <i className="bi bi-pencil-square fs-16"></i>
                                                                                                    </button>
                                                                                                    <button type='button' className="btn btn-soft-danger btn-sm d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }} onClick={() => handleCustfuncDelete(custom)} title="Delete">
                                                                                                        <i className="bi bi-trash fs-16"></i>
                                                                                                    </button>
                                                                                                </div>
                                                                                            </div>
                                                                                            <p className="text-muted fs-14 mb-2">{custom.function_description}</p>
                                                                                            <div className="mb-2">
                                                                                                <span className="text-muted fs-13 me-1"><b>URL:</b></span>
                                                                                                <span className="fs-13 text-break">{custom.url}</span>
                                                                                            </div>
                                                                                            <div className="mb-2">
                                                                                                <span className="text-muted fs-13 me-2"><b>Method:</b></span>
                                                                                                <span className="badge rounded-pill bg-primary-subtle text-primary">{custom.url_type}</span>
                                                                                            </div>
                                                                                            <div>
                                                                                                <span className="text-muted fs-13 me-1"><b>Parameters:</b></span>
                                                                                                <div className="d-flex flex-wrap gap-1 mt-1">
                                                                                                    {custom?.parameters.map((param, idx) => (
                                                                                                        <span key={idx} className="badge rounded-pill bg-secondary-subtle text-secondary">{param.name} : {param.type}</span>
                                                                                                    ))}
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            )
                                                                        })}

                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='d-flex justify-content-end gap-2 mt-2'>
                                                        {/* {isupdate && <input type="button" name="next" className="btn btn-md btn-primary previous action-button-previous" value="Skip For Now" onClick={() => setstep(step + 1)} />} */}
                                                        {isupdate && <Button variant='outline-warning' onClick={() => {
                                                            const formData = getValues();
                                                            setStep1Data(formData);
                                                            setstep(step + 1);
                                                        }}>Skip for Now</Button>}

                                                        <input type="button" name="previous" className="btn btn-md btn-secondary previous action-button-previous" value="Previous" onClick={() => setstep(step - 1)} />

                                                        <button className="btn btn-md btn-primary" type="submit" disabled={disabled}>
                                                            {/* {disabled ? <span className="spinner-border spinner-border-sm" role="status"  ></span> : ""} */}
                                                            Save and continue
                                                        </button>


                                                    </div>

                                                </fieldset>


                                                <fieldset className={step == 2 ? "active" : ""}>
                                                    <div className="form-card">
                                                        {/* START MODE SELECTION */}
                                                        {!promptMode && (
                                                            <div className="p-4 mb-4 bg-white border rounded-3">
                                                                <h5 className="mb-4 text-dark fw-bold d-flex align-items-center">
                                                                    <i className="bi bi-gear-fill me-2" style={{ color: '#014670' }}></i>System Prompt Configuration
                                                                    <Tooltip title="Choose how to configure your agent's system prompt" arrow placement="top">
                                                                        <InfoOutlined sx={{ fontSize: 16, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                                    </Tooltip>
                                                                </h5>
                                                                <div className="row g-3">
                                                                    <div className="col-md-6">
                                                                        <div
                                                                            className="card h-100 border-hover text-center"
                                                                            style={{ cursor: "pointer", border: 'dashed 1px #779dc5ff' }}
                                                                            onClick={() => { setPromptMode("scratch"); setFlowchartHtml(""); }}
                                                                        >
                                                                            <div className="card-body">
                                                                                <i className="bi bi-pencil-square fs-2 text-primary mb-2"></i>
                                                                                <h6 className="fw-bold">Start from Scratch</h6>
                                                                                <p className="text-muted fs-13 mb-0">
                                                                                    Write your own system prompt manually
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col-md-6">
                                                                        <div
                                                                            className="card h-100 border-hover text-center"
                                                                            style={{ cursor: "pointer", border: 'dashed 1px #7ec577ff' }}
                                                                            onClick={() => { setcusModal(true) }}
                                                                        >
                                                                            <div className="card-body">
                                                                                <i className="bi bi-lightning-charge fs-2 text-success mb-2"></i>
                                                                                <h6 className="fw-bold">Use Default Prompt</h6>
                                                                                <p className="text-muted fs-13 mb-0">
                                                                                    Load recommended default system prompt
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {/* SYSTEM PROMPT */}
                                                        {promptMode && (
                                                            <div className="p-4 mb-4 bg-white border rounded-3">
                                                                <h5 className="mb-4 text-dark fw-bold d-flex align-items-center">
                                                                    <i className="bi bi-pencil-square me-2" style={{ color: '#014670' }}></i>System Prompt & Flow Diagram
                                                                    <Tooltip title="Edit system prompt and visualize workflow" arrow placement="top">
                                                                        <InfoOutlined sx={{ fontSize: 16, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                                    </Tooltip>
                                                                </h5>

                                                                <div className='d-flex justify-content-between gap-2 align-items-center mb-3'>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                                                                        onClick={() => { setPromptMode(null); setValue("system_prompt", ""); }}
                                                                    >
                                                                        <i className="bi bi-arrow-left"></i>
                                                                        Change Mode
                                                                    </button>
                                                                    {flowchartHtml &&
                                                                        <button
                                                                            type="button"
                                                                            className="btn btn-sm btn-primary d-flex align-items-center gap-1"
                                                                            onClick={handleGenerateImage}
                                                                        >
                                                                            <i className="bi bi-arrow-clockwise"></i>
                                                                            Regenerate
                                                                        </button>
                                                                    }

                                                                </div>

                                                                <div className="row g-3">
                                                                    {/* LEFT: System Prompt */}
                                                                    <div className="col-md-5">
                                                                        <div className="d-flex justify-content-between align-items-center mb-2">
                                                                            <label htmlFor="SystemPrompt" className="form-label mb-0">
                                                                                System Prompt <span className='text-danger'>*</span>
                                                                                <Tooltip title="Define the system prompt that controls your agent's behavior, personality, and response guidelines. This is the core instruction set for your AI agent." arrow placement="top">
                                                                                    <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                                </Tooltip>
                                                                            </label>



                                                                            <button
                                                                                type="button"
                                                                                className="btn btn-sm btn-success rounded-pill d-flex gap-1 align-items-center"
                                                                                onClick={() => setbuildModal(true)}
                                                                            >
                                                                                <i className="bi bi-stars "></i>
                                                                                Generate with AI
                                                                            </button>



                                                                        </div>

                                                                        <textarea
                                                                            className="form-control"
                                                                            id="SystemPrompt"
                                                                            rows="3"
                                                                            placeholder={
                                                                                promptMode === "scratch"
                                                                                    ? "Write your system prompt from scratch..."
                                                                                    : promptMode === "default"
                                                                                        ? "Default system prompt loaded..."
                                                                                        : "AI-generated system prompt..."
                                                                            }
                                                                            {...register("system_prompt", {
                                                                                required:
                                                                                    step === 2
                                                                                        ? { value: true, message: "System Prompt is required" }
                                                                                        : false,
                                                                            })}
                                                                            style={{ minHeight: "400px" }}
                                                                        />

                                                                        {errors.system_prompt && (
                                                                            <p className="text-danger mt-1">{errors.system_prompt.message}</p>
                                                                        )}

                                                                        <div className='d-flex gap-1 align-items-center mt-2  justify-content-end'>

                                                                            <button
                                                                                type="button"
                                                                                disabled={loading}
                                                                                className="btn btn-sm btn-primary  "
                                                                                onClick={handleGenerateImage}
                                                                            >
                                                                                Generate Flow Diagram
                                                                            </button>
                                                                        </div>
                                                                    </div>

                                                                    {/* RIGHT: Flow Diagram */}
                                                                    <div className="col-md-7 ">
                                                                        <div
                                                                            className="border rounded-3 p-3 h-100"
                                                                            style={{
                                                                                backgroundColor: "#014670",
                                                                                borderColor: "#1e293b",
                                                                                boxShadow: "0 0 0 1px rgba(148,163,184,0.05)"
                                                                            }}
                                                                        >
                                                                            {/* Header */}
                                                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <i className="bi bi-diagram-3 fs-5 text-info"></i>
                                                                                    <h6 className="mb-0 fw-semibold fs-5 text-white">
                                                                                        Flow Diagram Preview
                                                                                    </h6>
                                                                                </div>
                                                                                <div>
                                                                                    <button
                                                                                        className="btn btn-sm btn-outline-info"
                                                                                        onClick={() => setShowFullscreenModal(true)}
                                                                                        title="Fullscreen"
                                                                                        type='button'
                                                                                        disabled={!flowchartHtml}
                                                                                    >
                                                                                        <i className="bi bi-fullscreen"></i>
                                                                                    </button>
                                                                                </div>
                                                                            </div>

                                                                            {/* Content */}
                                                                            {flowchartHtml ? (
                                                                                <iframe
                                                                                    ref={flowchartRef}
                                                                                    title="Flowchart Diagram"
                                                                                    srcDoc={flowchartHtml}
                                                                                    className="w-100 rounded-2"
                                                                                    style={{
                                                                                        minHeight: "500px",
                                                                                        border: "1px solid #c5cfdf",
                                                                                        backgroundColor: "#ffffff",
                                                                                        transition: "all 0.3s ease"
                                                                                    }}
                                                                                />
                                                                            ) : (
                                                                                <div
                                                                                    className="d-flex flex-column justify-content-center align-items-center text-center rounded-3"
                                                                                    style={{
                                                                                        minHeight: "400px",
                                                                                        background: "linear-gradient(180deg, #ffffff, #e3e7f8)",
                                                                                        border: "1px dashed #334155"
                                                                                    }}
                                                                                >
                                                                                    <i className="bi bi-diagram-3 fs-1 text-secondary mb-3"></i>

                                                                                    <h6 className="fw-semibold text mb-1">
                                                                                        No Flow Diagram Generated
                                                                                    </h6>

                                                                                    <p className="text-muted fs-5 small mb-0 px-4">
                                                                                        Generate the system prompt and click on the <strong className='text-primary'>Generate Flow Diagram </strong> to
                                                                                        visualize the workflow as a flow diagram here.
                                                                                    </p>
                                                                                </div>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}


                                                        <div className='d-flex justify-content-end gap-2'>
                                                            {isupdate &&
                                                                <>
                                                                    <Button variant='outline-warning' onClick={() => navigate('/configurations/agentconfigurations')}>Skip for Now</Button>
                                                                    <input
                                                                        type="button"
                                                                        name="next"
                                                                        className="btn btn-md btn-primary border-0 previous action-button-previous w-auto px-2"
                                                                        value="Advanced Settings"
                                                                        // style={{ backgroundColor: '#6e83ca' }}
                                                                        onClick={() => {
                                                                            setstep(step + 1);
                                                                            setAdvancedSettings(true);
                                                                            submit(getValues(), true)
                                                                        }}
                                                                    /> </>}

                                                            {/* ACTION BUTTONS */}
                                                            <input
                                                                type="button"
                                                                name="previous"
                                                                disabled={disabled}
                                                                className="btn btn-md btn-secondary  "
                                                                value="Previous"
                                                                onClick={() => {
                                                                    setstep(step - 1);
                                                                    setAdvancedSettings(false);
                                                                }}
                                                            />


                                                            <button
                                                                className=" btn btn-md btn-success"
                                                                type="submit"
                                                                disabled={disabled}
                                                            >
                                                                {disabled && (
                                                                    <span
                                                                        className="spinner-border spinner-border-sm me-1"
                                                                        role="status"
                                                                    ></span>
                                                                )}
                                                                Save
                                                            </button>


                                                        </div>

                                                    </div>
                                                </fieldset>

                                                <fieldset className={step == 3 ? "active" : ""}>
                                                    <div className="p-4 mb-4 bg-white border rounded-3">
                                                        <h5 className="mb-4 text-dark fw-bold d-flex align-items-center">
                                                            <i className="bi bi-mic-fill me-2" style={{ color: '#014670' }}></i>Transcription Settings
                                                            <Tooltip title="Configure transcription provider, model, and language" arrow placement="top">
                                                                <InfoOutlined sx={{ fontSize: 16, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                            </Tooltip>
                                                        </h5>
                                                        <div className="row g-3">
                                                            <div className="col-md-4">
                                                                <label htmlFor="ProviderTranscriber" className="form-label">
                                                                    Provider:
                                                                    <Tooltip title="Select the speech-to-text provider (e.g., Google, Azure, or Deepgram) for transcribing caller audio" arrow placement="top">
                                                                        <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                    </Tooltip>
                                                                </label>
                                                                <select
                                                                    id="ProviderTranscriber"
                                                                    className="form-select"
                                                                    {...register("transcriber_provider", {
                                                                        required: step === 3 ? { value: true, message: "Provider is required" } : false
                                                                    })}
                                                                    onChange={handleTranscriberProviderChange}
                                                                >
                                                                    <option value="">Choose Provider</option>
                                                                    {TranscriberprovidersModels.map((provider, i) => (
                                                                        <option value={provider.provider} key={'transcribeprovider' + i}>
                                                                            {provider.provider}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                                {errors.transcriber_provider && <p className='text-danger'>{errors.transcriber_provider.message}</p>}
                                                            </div>

                                                            <div className="col-md-4">
                                                                <label htmlFor="ModelTranscriber" className="form-label">
                                                                    Model:
                                                                    <Tooltip title="Select the specific transcription model from the chosen provider" arrow placement="top">
                                                                        <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                    </Tooltip>
                                                                </label>
                                                                <select
                                                                    id="ModelTranscriber"
                                                                    className="form-select"
                                                                    {...register("model", {
                                                                        required: step === 3 ? { value: true, message: "Model is required" } : false
                                                                    })}
                                                                    onChange={handleModelChange}
                                                                >
                                                                    <option value="">Choose Model</option>
                                                                    {availableModels.map((model, i) => (
                                                                        <option value={model} key={'transcribemodel' + i}>{model}</option>
                                                                    ))}
                                                                </select>
                                                                {errors.model && <p className='text-danger'>{errors.model.message}</p>}
                                                            </div>

                                                            <div className="col-md-4">
                                                                <label htmlFor="LanguageTranscriber" className="form-label">
                                                                    Language:
                                                                    <Tooltip title="Choose the language your agent should recognize and transcribe" arrow placement="top">
                                                                        <InfoOutlined sx={{ fontSize: 16, color: 'text.secondary', cursor: 'help', marginLeft: 1 }} />
                                                                    </Tooltip>
                                                                </label>
                                                                <select
                                                                    id="LanguageTranscriber"
                                                                    className="form-select"
                                                                    {...register("language", {
                                                                        required: step === 3 ? { value: true, message: "Language is required" } : false
                                                                    })}
                                                                >
                                                                    <option value="">Choose Language</option>
                                                                    {availableLanguages.map((lang, i) => (
                                                                        <option value={lang.code} key={'transcribelanguage' + i}>{lang.name}</option>
                                                                    ))}
                                                                </select>
                                                                {errors.language && <p className='text-danger'>{errors.language.message}</p>}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="p-4 mb-4 bg-white border rounded-3">
                                                        <h5 className="mb-4 text-dark fw-bold d-flex align-items-center">
                                                            <i className="bi bi-gear-fill me-2" style={{ color: '#014670' }}></i>Advanced Transcription Options
                                                            <Tooltip title="Configure advanced transcription features" arrow placement="top">
                                                                <InfoOutlined sx={{ fontSize: 16, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                            </Tooltip>
                                                        </h5>
                                                        <div className="row g-3">
                                                            <div className="col-xl-6 col-lg-6 col-md-12">
                                                                <div className="card mb-1 bg-light px-2 py-1 border">
                                                                    <div className="p-2">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-auto">
                                                                                <div className="avatar-sm">
                                                                                    <span className="avatar-title bg-primary-subtle rounded">
                                                                                        <i class="bi-mic-mute-fill fs-4"></i>

                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col ps-0">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <h5 className="mb-0">Background Denoising Enabled</h5>
                                                                                    <Tooltip title="Filter out background noise while the user is talking to improve transcription quality" arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <p className="mb-0 font-size-13">Filter background noise while the user is talking.</p>
                                                                            </div>
                                                                            <div className="col-auto">
                                                                                <div className="form-check form-switch">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input form-check-input-custom"
                                                                                        {...register("background_denoising")}
                                                                                        onChange={(e) => setValue("background_denoising", e.target.checked)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6 col-lg-6 col-md-12">
                                                                <div className="card mb-1 px-2 py-1 bg-light shadow-none border">
                                                                    <div className="p-2">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-auto">
                                                                                <div className="avatar-sm">
                                                                                    <span className="avatar-title bg-primary-subtle rounded">
                                                                                        <i className="bi bi-123 fs-4"></i>

                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col ps-0">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <h5 className="mb-0">Use Numerals</h5>
                                                                                    <Tooltip title="Convert spoken numbers into numerical digits in the transcription (e.g., 'twenty-three' becomes '23')" arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <p className="mb-0 font-size-13">Convert numbers from words to digits in transcription.</p>
                                                                            </div>
                                                                            <div className="col-auto">
                                                                                <div className="form-check form-switch">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input form-check-input-custom"
                                                                                        {...register("use_numerals")}
                                                                                        onChange={(e) => setValue("use_numerals", e.target.checked)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6 col-lg-6 col-md-12">
                                                                <div className="card mb-1 px-2 py-1 bg-light shadow-none border">
                                                                    <div className="p-2">
                                                                        <div className="row align-items-start">
                                                                            <div className="col-auto">
                                                                                <div className="avatar-sm">
                                                                                    <span className="avatar-title bg-primary-subtle rounded">
                                                                                        <i className="bi bi-shield-check fs-4"></i>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col ps-0">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <h5 className="mb-0">Confidence Threshold</h5>
                                                                                    <Tooltip title="Set a minimum confidence level for transcriptions. Audio with lower confidence scores will be filtered out." arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <p className="mb-1 font-size-13">
                                                                                    Transcripts with a confidence score below this threshold will be filtered out.
                                                                                </p>

                                                                                <div className="progress-w-percent mb-0">
                                                                                    <span className="badge text-black badge-outline-dark ms-1">
                                                                                        {watch("confidence_threshold") || 0.5}
                                                                                    </span>

                                                                                    <div className="">
                                                                                        <input
                                                                                            type="range"
                                                                                            id="confidence_threshold"
                                                                                            name="confidence_threshold"
                                                                                            min="0.1"
                                                                                            style={{ width: "100%" }}
                                                                                            max="1"
                                                                                            step="0.01"
                                                                                            value={watch("confidence_threshold") || 0.5}
                                                                                            {...register("confidence_threshold", {
                                                                                                required:
                                                                                                    step == 3 ? { value: true, message: "Confidence Threshold is required" } : false
                                                                                            })}
                                                                                        />
                                                                                    </div>

                                                                                    {/* ✅ Move error message below the bar */}
                                                                                    {errors.confidence_threshold && (
                                                                                        <p className="text-danger mt-1">{errors.confidence_threshold.message}</p>
                                                                                    )}

                                                                                    <div className="d-flex justify-content-between">
                                                                                        <p className="mb-0">0</p>
                                                                                        <p className="mb-0 me-4 pe-2">1</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="col-xl-6 col-lg-6 col-md-12">
                                                                <div className="card mb-1 px-2 py-1 bg-light shadow-none border">
                                                                    <div className="p-2">
                                                                        <div className="row align-items-start">
                                                                            <div className="col-auto">
                                                                                <div className="avatar-sm">
                                                                                    <span className="avatar-title bg-primary-subtle rounded">
                                                                                        <i className="bi bi-clock-history fs-4"></i>

                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col ps-0">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <h5 className="mb-0 fw-semibold">Silence Duration</h5>
                                                                                    <Tooltip title="Set the duration of silence (in seconds) that triggers the end of transcription" arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <p className="mb-1 font-size-13">
                                                                                    Silence duration threshold for transcription end detection.
                                                                                </p>
                                                                                <div className="progress-w-percent mb-0">
                                                                                    <span className="badge text-black badge-outline-dark ms-1">
                                                                                        {watch("silence_duration") || 0.5}
                                                                                    </span>
                                                                                    <div className="">
                                                                                        <input
                                                                                            type="range"
                                                                                            id="silence_duration"
                                                                                            name="silence_duration"
                                                                                            min="0.1"
                                                                                            style={{ width: "100%" }}
                                                                                            max="1"
                                                                                            step="0.01"
                                                                                            value={watch("silence_duration") || 0.5}
                                                                                            {...register("silence_duration", {
                                                                                                required: step == 2
                                                                                                    ? { value: true, message: "Silence Duration is required" }
                                                                                                    : false
                                                                                            })}
                                                                                        />

                                                                                    </div>
                                                                                    {errors.silence_duration && (
                                                                                        <p className="text-danger">{errors.silence_duration.message}</p>
                                                                                    )}
                                                                                    <div className="d-flex justify-content-between">
                                                                                        <p className="mb-0">0</p>
                                                                                        <p className="mb-0 me-4 pe-2">1</p>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex justify-content-end gap-2'>
                                                        {isupdate && <input type="button" name="next" className="previous btn btn-outline-warning" value="Skip For Now" onClick={() => setstep(step + 1)} />}
                                                        <input type="button" name="previous" className="previous btn btn-secondary" value="Previous" onClick={() => { setstep(step - 1); setAdvancedSettings(false) }} />

                                                        <button className="next btn btn-primary" type="submit" disabled={disabled}>
                                                            {disabled ? <span className="spinner-border spinner-border-sm" role="status"  ></span> : ""}
                                                            Save and Continue
                                                        </button>


                                                    </div>
                                                </fieldset>
                                                <fieldset className={step == 4 ? "active" : ""}>
                                                    <div className="p-4 mb-4 bg-white border rounded-3">
                                                        <h5 className="mb-4 text-dark fw-bold d-flex align-items-center">
                                                            <i className="bi bi-sliders me-2" style={{ color: '#014670' }}></i>Call Features & Functions
                                                            <Tooltip title="Enable call control features and functions" arrow placement="top">
                                                                <InfoOutlined sx={{ fontSize: 16, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                            </Tooltip>
                                                        </h5>
                                                        <div className="row g-3">
                                                            <div className="col-xl-6 mb-3">
                                                                <div className="card mb-1 bg-light px-2 py-1 shadow-none border">
                                                                    <div className="p-2">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-auto">
                                                                                <div className="avatar-sm me-2">
                                                                                    <span className="avatar-title bg-primary-subtle  rounded">
                                                                                        <i className="bi bi-telephone-plus"></i>
                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col ps-0">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <h5 className="mb-0">Enable End Call Function</h5>
                                                                                    <Tooltip title="Allow your agent to initiate call termination on its own. Works best with advanced models like GPT-4." arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <p className="mb-0 font-size-13">This will allow the assistant to end the call from its side. (Best for gpt-4 and bigger models.)</p>
                                                                            </div>
                                                                            <div className="col-auto">
                                                                                <div className="form-check form-switch">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input form-check-input-custom"
                                                                                        {...register("enable_end_call_function")}
                                                                                        onChange={(e) => setValue("enable_end_call_function", e.target.checked)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6 mb-3">
                                                                <div className="card mb-1 bg-light px-2 py-1 shadow-none border">
                                                                    <div className="p-2">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-auto">
                                                                                <div className="avatar-sm me-2">
                                                                                    <span className="avatar-title bg-primary-subtle  rounded">
                                                                                        <i className="bi bi-grid-3x3-gap fs-4"></i>

                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col ps-0">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <h5 className="mb-0">Dial Keypad</h5>
                                                                                    <Tooltip title="Allow your agent to press keypad digits (0-9, *, #) during calls for IVR navigation" arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <p className="mb-0 font-size-13">This sets whether the assistant can dial digits on the keypad. Read More</p>
                                                                            </div>
                                                                            <div className="col-auto">
                                                                                <div className="form-check form-switch">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input form-check-input-custom"
                                                                                        id="dial_keypad"
                                                                                        {...register("dial_keypad")}
                                                                                        onChange={(e) => setValue("dial_keypad", e.target.checked)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6 mb-2" >
                                                                <div className="card mb-1 bg-light px-2 py-1 shadow-none border">
                                                                    <div className="p-2">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-auto">
                                                                                <div className="avatar-sm me-2">
                                                                                    <span className="avatar-title bg-primary-subtle  rounded">
                                                                                        <i className="bi bi-calendar-event fs-4"></i>

                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col ps-0">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <h5 className="mb-0">Auto Meeting Scheduling</h5>
                                                                                    <Tooltip title="Enable automatic calendar integration and meeting scheduling for your agent" arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <p className="mb-0 font-size-13">This sets whether the assistant can Auto Meeting Scheduling </p>
                                                                            </div>
                                                                            <div className="col-auto">
                                                                                <div className="form-check form-switch">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input form-check-input-custom"
                                                                                        id="auto_meeting_scheduling"
                                                                                        {...register("auto_meeting_scheduling")}
                                                                                        onChange={(e) => setValue("auto_meeting_scheduling", e.target.checked)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-xl-6 mb-2">
                                                                <div className="card mb-1 bg-light px-2 py-1 shadow-none border">
                                                                    <div className="p-2">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-auto">
                                                                                <div className="avatar-sm me-2">
                                                                                    <span className="avatar-title bg-primary-subtle  rounded">
                                                                                        <i className="bi bi-arrow-repeat fs-4 "></i>

                                                                                    </span>
                                                                                </div>
                                                                            </div>
                                                                            <div className="col ps-0">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <h5 className="mb-0">Call Back Function</h5>
                                                                                    <Tooltip title="Allow your agent to request callback functionality for later contact" arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <p className="mb-0 font-size-13">This sets whether the assistant can call back function. Read More</p>
                                                                            </div>
                                                                            <div className="col-auto">
                                                                                <div className="form-check form-switch">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input form-check-input-custom"
                                                                                        id="call_back_function"
                                                                                        {...register("call_back_function")}
                                                                                        onChange={(e) => setValue("call_back_function", e.target.checked)}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className='d-flex justify-content-end gap-2 mt-2'>
                                                        {isupdate && <input type="button" name="next" className="previous btn btn-outline-warning" value="Skip For Now" onClick={() => setstep(step + 1)} />}
                                                        <input type="button" name="previous" className="previous btn btn-secondary" value="Previous" onClick={() => setstep(step - 1)} />

                                                        <button className="next btn btn-primary" type="submit" disabled={disabled}>
                                                            {disabled ? <span className="spinner-border spinner-border-sm" role="status"  ></span> : ""}
                                                            Save and Continue
                                                        </button>


                                                    </div>
                                                </fieldset>

                                                <fieldset className={step == 5 ? "active" : ""}>
                                                    <div className="p-4 mb-4 bg-white border rounded-3">
                                                        <h5 className="mb-4 text-dark fw-bold d-flex align-items-center">
                                                            <i className="bi bi-hourglass-split me-2" style={{ color: '#014670' }}></i>Timing & Recording Options
                                                            <Tooltip title="Configure call timing and recording settings" arrow placement="top">
                                                                <InfoOutlined sx={{ fontSize: 16, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                            </Tooltip>
                                                        </h5>

                                                        {/* Sliders Row */}
                                                        <div className="row g-3">

                                                            {/* Wait Seconds */}
                                                            <div className="col-xl-6 col-md-12">
                                                                <div className="card bg-light shadow-none border">
                                                                    <div className="p-3">
                                                                        <div className="row align-items-start">
                                                                            <div className="col-auto">
                                                                                <div className="avatar-sm">
                                                                                    <span className="avatar-title bg-primary-subtle rounded">
                                                                                        <i className="bi bi-clock fs-4"></i>
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col ps-0">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <h6 className="mb-0">Wait Seconds</h6>
                                                                                    <Tooltip title="Set the duration (in seconds) the assistant waits for caller input before speaking" arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <p className="mb-1 font-size-13 text-muted">
                                                                                    Time the assistant waits before speaking.
                                                                                </p>

                                                                                <span className="badge text-black badge-outline-dark mb-1">
                                                                                    {watch("wait_seconds") || 30}s
                                                                                </span>

                                                                                <input
                                                                                    type="range"
                                                                                    min="1"
                                                                                    max="60"
                                                                                    step="1"
                                                                                    style={{ width: "100%" }}
                                                                                    value={watch("wait_seconds") || 30}
                                                                                    {...register("wait_seconds", {
                                                                                        required:
                                                                                            step === 5
                                                                                                ? { value: true, message: "Wait seconds is required" }
                                                                                                : false
                                                                                    })}
                                                                                />

                                                                                {errors.wait_seconds && (
                                                                                    <p className="text-danger mt-1">
                                                                                        {errors.wait_seconds.message}
                                                                                    </p>
                                                                                )}

                                                                                <div className="d-flex justify-content-between">
                                                                                    <small>1</small>
                                                                                    <small>60</small>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            {/* Silence Timeout */}
                                                            <div className="col-xl-6 col-md-12">
                                                                <div className="card bg-light shadow-none border">
                                                                    <div className="p-3">
                                                                        <div className="row align-items-start">
                                                                            <div className="col-auto">
                                                                                <div className="avatar-sm">
                                                                                    <span className="avatar-title bg-primary-subtle rounded">
                                                                                        <i className="bi bi-hourglass-split fs-4"></i>
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col ps-0">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <h6 className="mb-0">Silence Timeout</h6>
                                                                                    <Tooltip title="Maximum silence duration (in seconds) before the system automatically ends the call" arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <p className="mb-1 font-size-13 text-muted">
                                                                                    End call after inactivity.
                                                                                </p>

                                                                                <span className="badge text-black badge-outline-dark mb-1">
                                                                                    {watch("silence_timeout") || 15}s
                                                                                </span>

                                                                                <input
                                                                                    type="range"
                                                                                    min="3"
                                                                                    max="15"
                                                                                    step="1"
                                                                                    style={{ width: "100%" }}
                                                                                    value={watch("silence_timeout") || 15}
                                                                                    {...register("silence_timeout", {
                                                                                        required:
                                                                                            step === 5
                                                                                                ? { value: true, message: "Silence timeout is required" }
                                                                                                : false
                                                                                    })}
                                                                                />

                                                                                {errors.silence_timeout && (
                                                                                    <p className="text-danger mt-1">
                                                                                        {errors.silence_timeout.message}
                                                                                    </p>
                                                                                )}

                                                                                <div className="d-flex justify-content-between">
                                                                                    <small>3</small>
                                                                                    <small>15</small>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                        </div>
                                                    </div>

                                                    {/* Audio Recording */}
                                                    <div className="p-4 mb-4 bg-white border rounded-3">
                                                        <h5 className="mb-4 text-dark fw-bold d-flex align-items-center">
                                                            <i className="bi bi-mic-fill me-2" style={{ color: '#014670' }}></i>Audio Recording
                                                            <Tooltip title="Enable or disable conversation recording" arrow placement="top">
                                                                <InfoOutlined sx={{ fontSize: 16, color: '#6c757d', cursor: 'help', marginLeft: 1 }} />
                                                            </Tooltip>
                                                        </h5>
                                                        <div className="row g-3">
                                                            <div className="col-md-6">
                                                                <div className="card bg-light shadow-none border">
                                                                    <div className="p-3">
                                                                        <div className="row align-items-center">
                                                                            <div className="col-auto">
                                                                                <div className="avatar-sm">
                                                                                    <span className="avatar-title bg-primary-subtle rounded">
                                                                                        <i className="bi bi-mic fs-4"></i>
                                                                                    </span>
                                                                                </div>
                                                                            </div>

                                                                            <div className="col ps-0">
                                                                                <div className="d-flex align-items-center gap-2">
                                                                                    <h5 className="mb-0">Enable Audio Recording</h5>
                                                                                    <Tooltip title="Enable recording of all conversations with callers for quality assurance and compliance" arrow placement="top">
                                                                                        <InfoOutlined sx={{ fontSize: 14, color: 'text.secondary', cursor: 'help' }} />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <p className="mb-0 font-size-13 text-muted">
                                                                                    Record the conversation with the assistant.
                                                                                </p>
                                                                            </div>

                                                                            <div className="col-auto">
                                                                                <div className="form-check form-switch">
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        className="form-check-input form-check-input-custom"
                                                                                        {...register("audio_recording")}
                                                                                        onChange={(e) =>
                                                                                            setValue("audio_recording", e.target.checked)
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    {/* Footer */}
                                                    <div className="d-flex justify-content-end gap-2 mt-4">
                                                        <button
                                                            type="button"
                                                            className="btn btn-secondary"
                                                            onClick={() => setstep(step - 1)}
                                                        >
                                                            Previous
                                                        </button>

                                                        <button
                                                            className="btn btn-primary"
                                                            type="submit"
                                                            disabled={disabled}
                                                        >
                                                            {disabled && (
                                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                            )}
                                                            Save
                                                        </button>
                                                    </div>

                                                </fieldset>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>


                            <div className="offcanvas offcanvas-end canvas-width-2" data-bs-scroll="true" data-bs-backdrop="false" tabIndex="-1" id="offcanvasScrolling" aria-labelledby="offcanvasScrollingLabel">
                                <div className="offcanvas-header">
                                    <h5 id="offcanvasRightLabel" className="text-green">Create Agent </h5>
                                    <button type="button" className="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                                </div>
                                {/* <!-- end offcanvas-header--> */}
                                <div className="offcanvas-body">
                                    <div className="row">
                                        <div className="mb-3 col-md-6">
                                            <label htmlFor="Target" className="form-label">Name (This can be adjusted at any time after creation.) </label>
                                            <input type="text" className="form-control" id="Target" placeholder="Enter Assistant Name" />
                                        </div>
                                        <div className="col-xxl-12 col-lg-12">
                                            <div className="card  shadow-none border">
                                                <div className="p-2">
                                                    <div className="row align-items-center">
                                                        <div className="col-auto">
                                                            <div className=" ">
                                                                <span className=" ">
                                                                    <i className="ri-add-circle-line fw-normal fs-36"></i>
                                                                </span>
                                                            </div>
                                                        </div>
                                                        <div className="col ps-0">
                                                            <a className="text-muted fw-bold font-size-18">Start from Scratch</a>
                                                            <p className="mb-0 fs-13">This blank slate template with minimal configurations. It's a starting point for creating your custom assistant.</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="d-flex align-items-center my-3 px-5">
                                            <div className="flex-grow-1 border-top"></div>
                                            <div className="px-2 text-muted"><strong> OR </strong></div>
                                            <div className="flex-grow-1 border-top"></div>
                                        </div>


                                    </div>
                                    <div className="row">
                                        <h4>Choose a template</h4>
                                        <p>Here's a few templates to get you started, or you can create your own template and use it to create a new assistant.</p>
                                        <div className="col-md-6">
                                            <div className="card ">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center">
                                                        <i className=" ri-account-circle-line fs-20 text-success me-1"></i>
                                                        <div className="w-100">
                                                            <h5 className="mb-0">Lead Qualifier</h5>
                                                        </div>
                                                    </div>
                                                    <p className="card-text">A comprehensive template for resolving product issues, answering questions, and ensuring satisfying customer experiences with technical knowledge and empathy.</p>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card ">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center">
                                                        <i className="ri-briefcase-line fs-20 text-success me-1"></i>
                                                        <div className="w-100">
                                                            <h5 className="mb-0">Data Collector</h5>
                                                        </div>
                                                    </div>
                                                    <p className="card-text">A consultative template designed to identify qualified prospects, understand business challenges, and connect them with appropriate sales representatives.</p>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card ">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center">
                                                        <i className="ri-hand-coin-line fs-20 text-success me-1"></i>
                                                        <div className="w-100">
                                                            <h5 className="mb-0">Care Manager</h5>
                                                        </div>
                                                    </div>
                                                    <p className="card-text">A specialized template for efficiently booking, confirming, rescheduling, or canceling appointments while providing clear service information.</p>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card ">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center">
                                                        <i className="ri-newspaper-line  fs-20 text-success me-1"></i>
                                                        <div className="w-100">
                                                            <h5 className="mb-0">Info Collector</h5>
                                                        </div>
                                                    </div>
                                                    <p className="card-text">A methodical template for gathering accurate and complete information from customers while ensuring data quality and regulatory compliance.</p>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card ">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center">
                                                        <i className=" ri-p2p-fill fs-20 text-success me-1"></i>
                                                        <div className="w-100">
                                                            <h5 className="mb-0">Care Coordinator</h5>
                                                        </div>
                                                    </div>
                                                    <p className="card-text">A compassionate template for scheduling medical appointments, answering health questions, and coordinating patient services with HIPAA compliance.</p>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="card ">
                                                <div className="card-body">
                                                    <div className="d-flex align-items-center">
                                                        <i className=" ri-thumb-up-line fs-20 text-success me-1"></i>
                                                        <div className="w-100">
                                                            <h5 className="mb-0">Feedback Gatherer</h5>
                                                        </div>
                                                    </div>
                                                    <p className="card-text">An engaging template for conducting surveys, collecting customer feedback, and gathering market research with high completion rates.</p>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="mb-2 text-end">
                                            <button type="submit" className="btn btn-success  rounded px-3">Proceed</button>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="modal fade" id="centermodal" tabIndex="-1" aria-hidden="true">
                            </div>
                            <Modal show={hide} onHide={() => sethide(false)}>
                                <Modal.Header closeButton>
                                    <Modal.Title>Create Folder</Modal.Title>
                                </Modal.Header>
                                <form onSubmit={handleSubmit2(submitFolder)}>
                                    <Modal.Body>
                                        <div className="mb-3">
                                            <label htmlFor="folderName" className="form-label">Folder Name</label>
                                            <input
                                                type="text"

                                                id="folderName"
                                                name="folderName"
                                                {...register2("folder_name", { required: "Folder name is required" })}
                                                className="form-control"
                                                placeholder="Enter your Folder Name"
                                                autoComplete='off'
                                            />
                                            {errors2.folder_name && <small className="text-danger d-block mb-2">{errors2.folder_name.message}</small>}
                                        </div>


                                    </Modal.Body>
                                    <Modal.Footer>
                                        <button type="button" className="btn btn-warning  rounded px-3" onClick={() => sethide(false)}>Cancel</button>
                                        <button type="submit" className="btn btn-success  rounded px-3">Save</button>
                                    </Modal.Footer>
                                </form>
                            </Modal>

                            <Modal
                                show={openModal}
                                onHide={handleClose}
                                backdrop="static"
                                keyboard={false}
                                size="lg"
                                centered
                                className="dark-modal"
                            >
                                <Modal.Header closeButton className="border-1 light-modal-header" style={{ backgroundColor: '#dee1f3' }}>
                                    <Modal.Title style={{ color: '#014670' }}>{editcustomFunctionDataID ? 'Edit Custom Function' : 'Add Custom Function'}</Modal.Title>
                                </Modal.Header>

                                <Modal.Body>
                                    <form onSubmit={handleSubmit3(onSubmit)}>
                                        <div className="row g-2 mb-1">
                                            <div className="mb-1 col-md-4">
                                                <label className="form-label">
                                                    Function Name <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors3.function_name ? "is-invalid" : ""}`}
                                                    placeholder="Enter Function Name"
                                                    {...register3("function_name", {
                                                        required: "Function Name is required",
                                                        pattern: {
                                                            value: /^[A-Za-z_]+$/,
                                                            message: "Function Name must contain only alphabets and underscores",
                                                        },

                                                        minLength: { value: 2, message: "Function Name must be at least 2 characters" },
                                                    })}
                                                />
                                                {errors3.function_name && (
                                                    <div className="invalid-feedback">{errors3.function_name.message}</div>
                                                )}
                                            </div>

                                            <div className="mb-1 col-md-4">
                                                <label className="form-label">
                                                    API URL <span className="text-danger">*</span>
                                                </label>
                                                <input
                                                    type="text"
                                                    className={`form-control ${errors3.url ? "is-invalid" : ""}`}
                                                    placeholder="Enter API URL "
                                                    {...register3("url", {
                                                        required: "API URL  is required",
                                                        pattern: {
                                                            value: /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/,
                                                            message: "Enter a valid website URL",
                                                        }
                                                    })}
                                                />
                                                {errors3.url && (
                                                    <div className="invalid-feedback">{errors3.url.message}</div>
                                                )}
                                            </div>
                                            <div className="mb-1 col-md-4">
                                                <label className="form-label">
                                                    URL Type <span className="text-danger">*</span>
                                                </label>
                                                <select class="form-select" className={`form-control ${errors3.url_type ? "is-invalid" : ""}`} defaultValue=""
                                                    {...register3("url_type", {
                                                        required: "URL Type   is required",

                                                    })}>
                                                    <option value="">Choose URL Type </option>
                                                    <option value="POST">POST</option>
                                                    <option value="GET">GET</option>
                                                    <option value="PATCH">PATCH</option>
                                                    <option value="PUT53">PUT</option>
                                                    <option value="DELETE">DELETE</option>
                                                </select>
                                                {errors3.url_type && (
                                                    <div className="invalid-feedback">{errors3.url_type.message}</div>
                                                )}

                                            </div>
                                            <div className="mb-1 col-md-4">
                                                <label className="form-label fw-medium">
                                                    Data Type <span className="text-danger">*</span>
                                                </label>

                                                <div className='d-flex gap-2'>
                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="data_type"
                                                            id="formData"
                                                            value="form-data"
                                                            {...register3("data_type", {
                                                                required: "Data Type is required",
                                                            })}
                                                        />
                                                        <label className="form-check-label" htmlFor="formData">
                                                            Form Data
                                                        </label>
                                                    </div>

                                                    <div className="form-check">
                                                        <input
                                                            className="form-check-input"
                                                            type="radio"
                                                            name="data_type"
                                                            id="rawData"
                                                            value="raw"
                                                            {...register3("data_type")}
                                                        />
                                                        <label className="form-check-label" htmlFor="rawData">
                                                            Raw Data
                                                        </label>
                                                    </div>
                                                </div>
                                                {errors3.data_type && (
                                                    <div className="text-danger small mt-1">
                                                        {errors3.data_type.message}
                                                    </div>
                                                )}
                                            </div>


                                            <div className="mb-1 col-md-8">
                                                <label className="form-label">
                                                    Description <span className="text-danger">*</span>
                                                </label>
                                                <textarea
                                                    type="text"
                                                    className={`form-control ${errors3.function_description ? "is-invalid" : ""}`}
                                                    placeholder="Enter Description"
                                                    {...register3("function_description", {
                                                        required: "Description is required",

                                                    })}
                                                />
                                                {errors3.function_description && (
                                                    <div className="invalid-feedback">{errors3.function_description.message}</div>
                                                )}
                                            </div>
                                            {/* <hr /> */}
                                            <div className=''>
                                                <p className='text-primary fw-semibold'>Request Parameters</p>
                                            </div>
                                            <div className='card  p-2 shadow-none border' style={{ borderRadius: '10px' }}>

                                                <div className='row'>
                                                    {requestParams.map((params, i) => {
                                                        return (
                                                            <>
                                                                <div className='col-md-4  mb-2  '>
                                                                    <label className="form-label">
                                                                        Parameter Name <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Parameter Name"
                                                                        value={params.name}
                                                                        onChange={(e) => changeParameterNameandLabel(e.target.value, i, 'name')}
                                                                    />

                                                                </div>
                                                                <div className='col-md-3  mb-2  '>
                                                                    <label className="form-label">
                                                                        Data Type <span className="text-danger">*</span>
                                                                    </label>
                                                                    <select class="form-select" value={params.type} onChange={(e) => changeParameterNameandLabel(e.target.value, i, 'type')}>
                                                                        <option value="">Choose Type</option>
                                                                        <option value="String">String</option>
                                                                        <option value="Number">Number</option>
                                                                        <option value="Array">Array</option>
                                                                        <option value="Object">Object</option>
                                                                        <option value="Boolen">Boolen</option>
                                                                    </select>

                                                                </div>
                                                                <div className='col-md-3  mb-2  '>
                                                                    <label className="form-label">
                                                                        Description <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className={`form-control `}
                                                                        placeholder="Enter Description"
                                                                        value={params.description}
                                                                        onChange={(e) => changeParameterNameandLabel(e.target.value, i, 'description')}
                                                                    />
                                                                    {errors.target_lead_phone && (
                                                                        <div className="invalid-feedback">{errors.target_lead_phone.message}</div>
                                                                    )}
                                                                </div>
                                                                <div className='col-md-1  mb-2'>
                                                                    <label className="form-label">Required</label>
                                                                    <input type='checkbox' checked={params.required} onChange={(e) => changeParameterNameandLabel(e.target.checked, i, 'required')} />

                                                                </div>
                                                                <div className='col-md-1  mb-2'>

                                                                    <span class="btn btn-link fs-16  p-1 text-danger mt-3" onClick={() => removeRequestParam(i)}><i class="bi bi-trash"></i></span>
                                                                </div>

                                                                <div className='col-md-12'>
                                                                    <span className='text-danger'>  {errorForParams}</span>
                                                                </div>
                                                            </>
                                                        )
                                                    })}





                                                </div>

                                                <div className='col-md-12'>
                                                    <div className='mt-2 text-end' id='msform'>
                                                        <button className="next action-button btn btn-success  fw-bold  "
                                                            style={{
                                                                width: '35px',
                                                                height: '35px',
                                                                borderRadius: '50%',
                                                                fontSize: '22px',
                                                                padding: 0
                                                            }} type="button" onClick={() => AddNewParamsToDist()} >
                                                            +
                                                        </button>

                                                    </div>
                                                </div>
                                            </div>


                                            <div className=''>
                                                <p className='text-primary fw-bold'>Headers</p>
                                            </div>
                                            <div className='card p-2 shadow-none border'>
                                                <div className='row'>
                                                    {headers.map((header, i) => {
                                                        return (
                                                            <React.Fragment key={i}>
                                                                <div className='col-md-5 mb-2'>
                                                                    <label className="form-label">
                                                                        Header Key <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="e.g., X-API-Key"
                                                                        value={header.key}
                                                                        onChange={(e) => changeHeaderKeyValue(e.target.value, i, 'key')}
                                                                    />
                                                                </div>
                                                                <div className='col-md-6 mb-2'>
                                                                    <label className="form-label">
                                                                        Header Value <span className="text-danger">*</span>
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        className="form-control"
                                                                        placeholder="Enter Header Value"
                                                                        value={header.value}
                                                                        onChange={(e) => changeHeaderKeyValue(e.target.value, i, 'value')}
                                                                    />
                                                                </div>
                                                                <div className='col-md-1 mb-2'>
                                                                    <label className="form-label">&nbsp;</label>
                                                                    <span className="btn btn-link fs-16 p-1 text-danger d-block" onClick={() => removeHeader(i)}>
                                                                        <i className="bi bi-trash-fill"></i>
                                                                    </span>
                                                                </div>
                                                            </React.Fragment>
                                                        )
                                                    })}
                                                </div>
                                                <div className='col-md-12'>
                                                    <div className='mt-2 text-end' id='msform'>
                                                        <button className="btn btn-sm btn-success " type="button" onClick={() => AddNewHeader()}>
                                                            Add Header
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>



                                        </div>

                                        <div className="text-center mt-3 d-flex justify-content-end gap-2" id='msform'>

                                            <button className="next action-button btn btn-secondary text-white" type="button" disabled={disabled}
                                                onClick={handleClose}>
                                                Cancel
                                            </button>
                                            <button className="next action-button btn btn-primary" type="submit">
                                                {editcustomFunctionDataID ? 'Update Function' : 'Add Function'}
                                            </button>


                                        </div>
                                    </form>
                                </Modal.Body>
                            </Modal>

                            {/* <Modal
                    show={successModal}
                    centered
                    backdrop="static"
                    keyboard={false}
                    className="success-modal"
                >
                    <Modal.Body className="text-center p-4">
                        <div className="mb-3">
                            <i className="ri-check-double-line text-success" style={{ fontSize: '60px' }}></i>
                        </div>
                        <h5 className="mb-2">{successTitle}</h5>
                        <p className="text-muted mb-0">{successMessage}</p>
                    </Modal.Body>
                </Modal> */}

                            {/* SUCCESS MODAL */}
                            <Modal
                                show={successModal}
                                onHide={() => setSuccessModal(false)}
                                centered
                                backdrop="static"
                                contentClassName="border-0 shadow-lg rounded-4"
                            >
                                <Modal.Body className="p-4 text-center">
                                    {/* Icon */}
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                        style={{
                                            width: 80,
                                            height: 80,
                                            background: "linear-gradient(135deg, #28a745, #20c997)",
                                        }}
                                    >
                                        <i className="bi bi-check-lg" style={{ fontSize: "2.5rem" }} />
                                    </div>

                                    {/* Title */}
                                    <h5 className="mb-2">{successTitle}</h5>
                                    <p className="text-muted mb-0">{successMessage}</p>

                                    {/* Action */}
                                    <Button
                                        variant="success"
                                        className="px-4 fw-semibold rounded-pill"
                                        onClick={() => setSuccessModal(false)}
                                    >
                                        Done
                                    </Button>
                                </Modal.Body>
                            </Modal>

                            <Modal
                                show={errorModal}
                                onHide={() => setErrorModal(false)}
                                centered
                                backdrop="static"
                            >
                                <Modal.Body className="text-center p-4">
                                    {/* Icon */}
                                    <div className="mb-1">
                                        <div
                                            className="rounded-circle d-inline-flex align-items-center justify-content-center border border-danger "
                                            style={{ width: 56, height: 56 }}
                                        >
                                            <i className="bi bi-exclamation-lg fs-3 text-danger"></i>
                                        </div>
                                    </div>

                                    {/* Title */}
                                    <h5 className="fw-semibold text-danger mb-2">Something went wrong</h5>

                                    {/* Message */}
                                    <p className="text-white mb-4 fs-4">
                                        {errorMessage || "We couldn’t complete the action. Please try again."}
                                    </p>

                                    {/* Action */}
                                    <button
                                        className="btn btn-danger px-4"
                                        onClick={() => setErrorModal(false)}
                                    >
                                        Okay
                                    </button>
                                </Modal.Body>
                            </Modal>

                            <Modal show={buildModal} onHide={() => setbuildModal(false)} centered keyboard={false} backdrop="static" className="success-modal">
                                <Modal.Header closeButton className="border-1 light-modal-header" style={{ backgroundColor: '#dee1f3' }}>
                                    <Modal.Title className=" d-flex align-items-center gap-2" style={{ color: '#014670' }}>
                                        <i className="bi bi-stars "></i>
                                        Create Using AI
                                    </Modal.Title>
                                </Modal.Header>
                                <Modal.Body className="">
                                    <form onSubmit={handleSubmit1(onSubmitAI)} className="form-horizontal">
                                        {/* <label className="form-label">
                                Agent Type: <span><i className="ri-information-line fs-16"></i></span>
                            </label>
                            <select
                                className="form-select"
                                {...register1("agent_type", {
                                    required: "Agent Type is required",
                                })}
                            >
                                <option value="">Choose agent type</option>
                                <option value="in-bound">Inbound</option>
                                <option value="out-bound">Outbound</option>
                            </select>
                            {errors1.agent_type && <p className="text-danger">{errors1.agent_type.message}</p>} */}

                                        <div className="">
                                            <div className="d-flex justify-content-start align-items-center mb-2">
                                                <label htmlFor="custom" className="form-label mb-0">
                                                    Provide Your Custom Persona <span className='text-danger'>*</span>: <span><i className="ri-information-line fs-16"></i></span>
                                                </label>
                                            </div>
                                            <textarea
                                                className="form-control"
                                                id="custom"
                                                {...register1("user_response", {
                                                    required: "Describe your custom persona is required"
                                                })}
                                                rows="4"
                                                placeholder="Describe the agent's role, tone, and purpose..."
                                            ></textarea>
                                            {errors1.user_response && <p className='text-danger'>{errors1.user_response.message}</p>}
                                        </div>

                                        <div className="text-center mt-3 d-flex justify-content-end gap-2">
                                            <button
                                                className="btn btn-secondary"
                                                type="button"
                                                disabled={aiLoading}
                                                onClick={() => { setbuildModal(false); reset1(); }}
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                className="btn btn-primary"
                                                type="submit"
                                                disabled={aiLoading}
                                            >
                                                {aiLoading ? (
                                                    <span
                                                        className="spinner-border spinner-border-sm me-2"
                                                        role="status"
                                                    ></span>
                                                ) : null}
                                                {aiLoading ? "Creating..." : "Create"}
                                            </button>
                                        </div>
                                    </form>
                                </Modal.Body>
                            </Modal>

                            <Modal
                                size="xl"
                                show={cusModal}
                                onHide={() => setcusModal(false)}
                                backdrop="static"
                                centered
                                keyboard={false}
                                fullscreen="lg-down"
                                className='dark-modal'
                            >
                                <Modal.Header className="border-1 light-modal-header" style={{ backgroundColor: '#dee1f3' }}>
                                    <Modal.Title className="fw-bold d-flex align-items-center gap-2" style={{ color: '#014076' }}>
                                        <i className="bi bi-collection-fill fs-4 "></i>
                                        Select Persona Template
                                    </Modal.Title>

                                    <button
                                        type="button"
                                        className="btn-close"
                                        aria-label="Close"
                                        onClick={() => setcusModal(false)}
                                    />
                                </Modal.Header>


                                <Modal.Body className="template-modal p-0">



                                    <div className="container-fluid ">
                                        <div className="row g-2">

                                            <div className="col-12 col-md-2 p-0 ">

                                                <div
                                                    className=" px-1 light-sidebar"
                                                    style={{
                                                        height: "100%",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                    }}
                                                >
                                                    <FilterSidebar
                                                        selectedFilter={selectedFilter}
                                                        onFilterChange={handleFilterChange}
                                                    />
                                                </div>


                                            </div>

                                            <div className="col-12 col-md-10 pb-3"
                                                style={{
                                                    height: "calc(100vh - 20vh )",
                                                    overflowY: "auto",
                                                    overflowX: 'hidden'           // enable scroll
                                                    // paddingRight: "8px"
                                                }}>

                                                <div
                                                    className="d-flex align-items-center justify-content-end gap-3 p-2 mb-1 light-sticky-bar"
                                                    style={{
                                                        position: "sticky",
                                                        top: 0,
                                                        zIndex: 50,
                                                    }}
                                                >

                                                    <div className="d-flex align-items-center gap-2">
                                                        <button
                                                            className={`btn btn-sm ${selectedType === "in-bound" ? "btn-success" : "btn-secondary"}`}
                                                            onClick={() => handleAgentTypeChange("in-bound")}
                                                        >
                                                            Inbound
                                                        </button>

                                                        <button
                                                            className={`btn btn-sm ${selectedType === "out-bound" ? "btn-success" : "btn-secondary"}`}
                                                            onClick={() => handleAgentTypeChange("out-bound")}
                                                        >
                                                            Outbound
                                                        </button>
                                                    </div>

                                                    <div className="position-relative">
                                                        <i
                                                            className="bi bi-search position-absolute"
                                                            style={{ top: "50%", left: "10px", transform: "translateY(-50%)" }}
                                                        ></i>
                                                        <input
                                                            type="text"
                                                            className="form-control form-control-sm ps-4"
                                                            placeholder="Search..."
                                                            value={searchFilter}
                                                            onChange={(e) => handleSearchFilterChange(e.target.value)}
                                                            style={{ width: "180px" }}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="row g-3">
                                                    {personaLoading ? (
                                                        <div className="col-12 d-flex justify-content-center align-items-center pt-5 mt-5">
                                                            <Loader />
                                                        </div>
                                                    ) : (
                                                        <>
                                                            {personaModels.length === 0 && !loading && (
                                                                <p className="text-center mt-5 pt-5">No personas found.</p>
                                                            )}

                                                            {personaModels.map((item) => (
                                                                <div
                                                                    className="col-12 col-sm-6 col-md-6 col-lg-4"
                                                                    key={item.prompt_id}
                                                                >
                                                                    <SidebarCard
                                                                        item={item}
                                                                        selectedId={selectedId}
                                                                        handleSelect={handleSelect}
                                                                    />
                                                                </div>
                                                            ))}
                                                        </>
                                                    )}
                                                </div>

                                            </div>

                                        </div>
                                    </div>

                                </Modal.Body>
                            </Modal>

                            <Modal
                                show={showSuccessModal}
                                onHide={() => setShowSuccessModal(false)}
                                centered
                                backdrop="static"
                                contentClassName="border-0 shadow-lg rounded-4"
                            >
                                <Modal.Body className="p-4 text-center">
                                    <div
                                        className="d-inline-flex align-items-center justify-content-center rounded-circle mb-3"
                                        style={{
                                            width: 80,
                                            height: 80,
                                            background: "linear-gradient(135deg, #28a745, #20c997)",
                                        }}
                                    >
                                        <i className="bi bi-check-lg text-white" style={{ fontSize: "2.5rem" }} />
                                    </div>
                                    <h5 className="fw-bold mb-2">Success</h5>
                                    <p className="text-muted mb-4">{successMessage}</p>
                                    <button
                                        className="btn btn-success px-4 fw-semibold rounded-pill"
                                        onClick={() => setShowSuccessModal(false)}
                                    >
                                        Done
                                    </button>
                                </Modal.Body>
                            </Modal>

                            <Modal
                                show={showFullscreenModal}
                                onHide={() => {
                                    setShowFullscreenModal(false);
                                    setModalZoomLevel(1); // Reset zoom when modal closes
                                }}
                                size="xl"
                                centered
                                backdrop="static"
                                contentClassName="border-0 shadow-lg rounded-2"
                                className="flowchart-fullscreen-modal"
                            >
                                {/* ===== HEADER ===== */}
                                <Modal.Header
                                    closeButton={false}
                                    className="border-0 pb-2 pt-2 d-flex justify-content-between align-items-center"
                                    style={{ backgroundColor: '#014670' }}

                                >
                                    {/* ZOOM CONTROLS */}
                                    <div className="d-flex align-items-center gap-2">
                                        <button
                                            className="btn btn-sm btn-light"
                                            title="Zoom Out"
                                            onClick={() => handleZoomChange(-0.2)}
                                        >
                                            <i className="bi bi-zoom-out text-black"></i>
                                        </button>

                                        <span
                                            className="text-white small"
                                            style={{ minWidth: "50px", textAlign: "center" }}
                                        >
                                            {Math.round((modalZoomLevel * 2) * 100)}%
                                        </span>

                                        <button
                                            className="btn btn-sm btn-light"
                                            title="Zoom In"
                                            onClick={() => handleZoomChange(0.2)}
                                        >
                                            <i className="bi bi-zoom-in text-black"></i>
                                        </button>
                                    </div>

                                    {/* CLOSE */}
                                    <button
                                        className="btn btn-secondary btn-sm"
                                        onClick={() => setShowFullscreenModal(false)}
                                        title="Close"
                                    >
                                        <i className="bi bi-x-lg"></i>
                                    </button>
                                </Modal.Header>

                                {/* ===== BODY ===== */}

                                <Modal.Body style={{ backgroundColor: '#014670' }} >
                                    {flowchartHtml && (
                                        <iframe
                                            title="Flowchart Diagram Fullscreen"
                                            srcDoc={flowchartHtml}
                                            className="w-100 rounded-2"
                                            style={{
                                                minHeight: "800px",
                                                border: "1px solid #1e293b",
                                                backgroundColor: "#020617"
                                            }}
                                            onLoad={syncIframeZoom}
                                        />
                                    )}
                                </Modal.Body>
                            </Modal>
                        </div>

                    </div>
                </div>
            </div>


        </>
    )
}
